var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-button", on: { click: _vm.goToRiskInsiderPage } },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c("div", _vm._g({ staticClass: "home-button__icon" }, on), [
                    _c(
                      "svg",
                      {
                        staticStyle: {
                          "enable-background": "new 0 0 1080 1080",
                        },
                        attrs: {
                          id: "Layer_1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          x: "0px",
                          y: "0px",
                          height: "256px",
                          viewBox: "0 0 1080 1080",
                          "xml:space": "preserve",
                        },
                      },
                      [
                        _c("g", [
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_1_",
                                      d: "M773.5,679.5v-0.4v-0.4c0-0.4,0-0.4,0-0.8v-4.6c0,0.4,0,0.4,0,0.8v0.4l-0.4,0.4l0,0\n\t\t\t\t\t\tc0,0.4-0.4,0.4-0.4,0.8l0,0c-0.4,0.4-0.4,0.4-0.8,0.8v4.6l0,0h0.4h0.4l0.4-0.4l0,0l0,0h0.4L773.5,679.5L773.5,679.5\n\t\t\t\t\t\tL773.5,679.5L773.5,679.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000008831009199987834200000016790338902931565227_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: { "xlink:href": "#SVGID_1_" },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000008831009199987834200000016790338902931565227_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000085953200139172309500000016715796082009274293_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000139270231186510776150000008514002419429441689_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000085953200139172309500000016715796082009274293_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000139270231186510776150000008514002419429441689_)",
                                              "enable-background": "new",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000052096889704519278240000010699172508044742826_",
                                                        x: "770.6",
                                                        y: "672.5",
                                                        width: "4.6",
                                                        height: "8.7",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000085231437114445702100000009317776110518689169_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000052096889704519278240000010699172508044742826_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000085231437114445702100000009317776110518689169_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("path", {
                                                              attrs: {
                                                                id: "SVGID_00000005246118613025276730000002295817718676671406_",
                                                                d: "M773.5,679.5v-0.4v-0.4c0-0.4,0-0.4,0-0.8\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tv-4.6c0,0.4,0,0.4,0,0.8v0.4l-0.4,0.4l0,0c0,0.4-0.4,0.4-0.4,0.8l0,0c-0.4,0.4-0.4,0.4-0.8,0.8v4.6l0,0h0.4h0.4\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tl0.4-0.4l0,0l0,0h0.4L773.5,679.5L773.5,679.5L773.5,679.5L773.5,679.5",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000147915811609365715900000013813790123659334815_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000005246118613025276730000002295817718676671406_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000147915811609365715900000013813790123659334815_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000093158212135054322660000002665938928251432339_",
                                                                        x: "770.6",
                                                                        y: "672.5",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "8.7",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000023272013189288363730000010612512305320061614_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000093158212135054322660000002665938928251432339_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          opacity:
                                                                            "0",
                                                                          "clip-path":
                                                                            "url(#SVGID_00000023272013189288363730000010612512305320061614_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "g",
                                                                        {
                                                                          staticClass:
                                                                            "st5",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "g",
                                                                            [
                                                                              _c(
                                                                                "g",
                                                                                [
                                                                                  _c(
                                                                                    "g",
                                                                                    [
                                                                                      _c(
                                                                                        "defs",
                                                                                        [
                                                                                          _c(
                                                                                            "rect",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  id: "SVGID_00000119109732430591240890000014800388858828983212_",
                                                                                                  x: "770.6",
                                                                                                  y: "672.5",
                                                                                                  width:
                                                                                                    "4.6",
                                                                                                  height:
                                                                                                    "8.7",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "clipPath",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              id: "SVGID_00000114075818638978624480000017883799044221790626_",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "use",
                                                                                            {
                                                                                              staticStyle:
                                                                                                {
                                                                                                  overflow:
                                                                                                    "visible",
                                                                                                },
                                                                                              attrs:
                                                                                                {
                                                                                                  "xlink:href":
                                                                                                    "#SVGID_00000119109732430591240890000014800388858828983212_",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000124884401232240126790000004616671700490147494_",
                                                                        x: "770.6",
                                                                        y: "672.5",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "8.7",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000012458763024495405140000001798640959360255410_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000124884401232240126790000004616671700490147494_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "clip-path":
                                                                            "url(#SVGID_00000012458763024495405140000001798640959360255410_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c("g", [
                                                                        _c(
                                                                          "g",
                                                                          [
                                                                            _c(
                                                                              "g",
                                                                              [
                                                                                _c(
                                                                                  "defs",
                                                                                  [
                                                                                    _c(
                                                                                      "rect",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            id: "SVGID_00000085217329460749272980000015605206167769739668_",
                                                                                            x: "770.6",
                                                                                            y: "672.5",
                                                                                            width:
                                                                                              "4.6",
                                                                                            height:
                                                                                              "8.7",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "clipPath",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        id: "SVGID_00000144311476243058984750000017892726667086467751_",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "use",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            overflow:
                                                                                              "visible",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            "xlink:href":
                                                                                              "#SVGID_00000085217329460749272980000015605206167769739668_",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000174604051840770862560000017678128594639715238_",
                                      d: "M773.5,671.6c-0.4-0.4-0.4-0.4-0.8-0.8\n\t\t\t\t\t\tc1.2,1.2,0.4,3.3-1.2,4.6l0.4,1.2C773.9,675,774.8,673.3,773.5,671.6",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000039833179167593070070000000934475122472990362_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000174604051840770862560000017678128594639715238_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000039833179167593070070000000934475122472990362_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000092416570177083763660000010052010960051480990_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000148642449088705808230000004303037737001680527_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000092416570177083763660000010052010960051480990_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000148642449088705808230000004303037737001680527_)",
                                            fill: "#3FB994",
                                          },
                                          attrs: {
                                            x: "769",
                                            y: "668.3",
                                            width: "7.9",
                                            height: "10.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000093886539328810792350000015664978547048725423_",
                                      d: "M773.5,671.6c-0.4-0.4-0.4-0.4-0.8-0.8\n\t\t\t\t\t\tc1.2,1.2,0.4,3.3-1.2,4.6l0.4,1.2C773.9,675,774.8,673.3,773.5,671.6",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000064330295431733651990000003956461716696750779_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000093886539328810792350000015664978547048725423_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000064330295431733651990000003956461716696750779_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000031890166939544845110000017281155053508313780_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000011011576749183672800000004928920258766622080_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000031890166939544845110000017281155053508313780_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000011011576749183672800000004928920258766622080_)",
                                              "enable-background": "new",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000028311056558291525260000005789053362446922392_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000057144395919597909730000002162134518240886400_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000028311056558291525260000005789053362446922392_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000057144395919597909730000002162134518240886400_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000047060708576244301270000007015396914196451212_",
                                                                points:
                                                                  "771.4,675 771.9,676.6\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t771.9,676.2 771.4,675 771.4,675 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000022551465311570555760000018183511303804798604_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000047060708576244301270000007015396914196451212_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000022551465311570555760000018183511303804798604_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000075882099087140306480000014989446102903267213_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000016786955958402288560000014030575586872711302_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000075882099087140306480000014989446102903267213_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000016786955958402288560000014030575586872711302_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "769",
                                                                      y: "672.9",
                                                                      width:
                                                                        "5",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000163058433534278155100000006007067853663322755_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000158006799455615509980000007491586384497835694_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000163058433534278155100000006007067853663322755_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000158006799455615509980000007491586384497835694_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000083089211194674136850000012233352689566491794_",
                                                                points:
                                                                  "771.4,675 771.9,676.2\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t772.3,676.2 771.9,675 771.4,675 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000178203030224641028930000010671694416607998120_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000083089211194674136850000012233352689566491794_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000178203030224641028930000010671694416607998120_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000076597879816311855430000010935388158274897026_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000155852981105800057550000008294238049106913924_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000076597879816311855430000010935388158274897026_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000155852981105800057550000008294238049106913924_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "769.4",
                                                                      y: "672.9",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000042731460396828665720000001388263284596093842_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000059292955705705015430000011596069745396320176_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000042731460396828665720000001388263284596093842_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000059292955705705015430000011596069745396320176_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000114039139490628468570000008780552933486937015_",
                                                                points:
                                                                  "771.9,675 772.3,676.2\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t772.7,676.2 771.9,675 771.9,675 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000008858334146161230260000005325398917668349076_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000114039139490628468570000008780552933486937015_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000008858334146161230260000005325398917668349076_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000160877592613308399900000002101154845586294944_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000035530088690642964570000009549858813439905685_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000160877592613308399900000002101154845586294944_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000035530088690642964570000009549858813439905685_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "769.4",
                                                                      y: "672.5",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000075877969636882610730000000899822967620786583_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000073714120856361499050000008007598511093093537_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000075877969636882610730000000899822967620786583_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000073714120856361499050000008007598511093093537_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000011716883469640947530000012456758665438725799_",
                                                                points:
                                                                  "771.9,675 772.7,676.2\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t772.7,675.8 772.3,674.5 771.9,675 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000148661017716904516250000004475104816982795410_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000011716883469640947530000012456758665438725799_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000148661017716904516250000004475104816982795410_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000031911444307364738060000012580721399251077556_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000018209474082977270490000018225341218597851529_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000031911444307364738060000012580721399251077556_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000018209474082977270490000018225341218597851529_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "769.8",
                                                                      y: "672.5",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000104673386757454447430000014925073597468373691_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000052067018194240210620000006492149084663824575_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000104673386757454447430000014925073597468373691_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000052067018194240210620000006492149084663824575_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000081623788529388170920000002499356413506516919_",
                                                                points:
                                                                  "772.3,674.5 772.7,675.8\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t773.1,675.8 772.3,674.5 772.3,674.5 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000168102182693142274730000002717930282910609317_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000081623788529388170920000002499356413506516919_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000168102182693142274730000002717930282910609317_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000012447414184288898640000002647185310644267137_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000090987003549053335690000000982146849534682293_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000012447414184288898640000002647185310644267137_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000090987003549053335690000000982146849534682293_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "769.8",
                                                                      y: "672.1",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000042698918624834000590000009787173387052902820_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000148628708746165440710000002513640298811457207_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000042698918624834000590000009787173387052902820_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000148628708746165440710000002513640298811457207_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000134955337813439069250000017640627299980025274_",
                                                                points:
                                                                  "772.3,674.5 773.1,675.8\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t773.1,675.4 772.7,674.1 772.3,674.5 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000017500309622981459610000007285245319113570714_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000134955337813439069250000017640627299980025274_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000017500309622981459610000007285245319113570714_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000005964622140603377080000012438538371841647787_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000066490636964024474730000007518501475746856870_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000005964622140603377080000012438538371841647787_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000066490636964024474730000007518501475746856870_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "770.2",
                                                                      y: "672.1",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000019657326856413269130000007632286808593048738_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000132808980457298907390000008105611094223573125_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000019657326856413269130000007632286808593048738_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000132808980457298907390000008105611094223573125_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000058557737071579418960000008345166146873617317_",
                                                                points:
                                                                  "772.7,674.1 773.1,675.4\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t773.5,675.4 772.7,674.1 772.7,674.1 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000041265280767158194950000001048379306797983904_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000058557737071579418960000008345166146873617317_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000041265280767158194950000001048379306797983904_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000021087719694104189400000008133542448309726606_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000068655088666208744720000010899934250123425421_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000021087719694104189400000008133542448309726606_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000068655088666208744720000010899934250123425421_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "770.2",
                                                                      y: "671.6",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000024689793580249488000000010067872182651927231_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000064325100929049905170000007661349482502295478_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000024689793580249488000000010067872182651927231_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000064325100929049905170000007661349482502295478_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000129896264947270708940000004021529756391660440_",
                                                                points:
                                                                  "772.7,674.1 773.5,675.4\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t773.5,675 772.7,673.7 772.7,674.1 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000121264682811050808500000012619273249134095248_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000129896264947270708940000004021529756391660440_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000121264682811050808500000012619273249134095248_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000175309343147132834990000013774544840625601173_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000134946273672420761260000004050186764398610857_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000175309343147132834990000013774544840625601173_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000134946273672420761260000004050186764398610857_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "770.6",
                                                                      y: "671.6",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000078755723922779147390000014931583719095776915_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000166655175874861731860000002803271121335456415_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000078755723922779147390000014931583719095776915_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000166655175874861731860000002803271121335456415_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000043454190417790641480000000694305369722445462_",
                                                                points:
                                                                  "772.7,673.7 773.5,675 773.5,675\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t773.1,673.7 772.7,673.7 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000096754834446086953890000011399143550365345203_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000043454190417790641480000000694305369722445462_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000096754834446086953890000011399143550365345203_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000044158125924956276180000013174892698665217926_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000172401269718359605670000013069172853020203420_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000044158125924956276180000013174892698665217926_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000172401269718359605670000013069172853020203420_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "770.6",
                                                                      y: "671.2",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000041984474325509803350000015838274284509254572_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000023984081603383205080000004429505959515193763_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000041984474325509803350000015838274284509254572_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000023984081603383205080000004429505959515193763_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000060722462374270187220000010898554158552383647_",
                                                                points:
                                                                  "773.1,673.7 773.5,675\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t773.9,674.5 773.1,673.3 773.1,673.7 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000151508250732642524340000000452698337762519979_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000060722462374270187220000010898554158552383647_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000151508250732642524340000000452698337762519979_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000148654602035501279300000015777044693523748769_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000104678147340258497240000005904602583352814002_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000148654602035501279300000015777044693523748769_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000104678147340258497240000005904602583352814002_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "770.6",
                                                                      y: "671.2",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000095301700326426089110000002645562726669723010_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000160903261395813374710000011968612728172934586_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000095301700326426089110000002645562726669723010_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000160903261395813374710000011968612728172934586_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000062182798008354230010000001033991028648862848_",
                                                                points:
                                                                  "773.1,673.3 773.9,674.5\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t773.9,674.1 773.1,672.9 773.1,673.3 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000016772375644138380130000002282030205815866277_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000062182798008354230010000001033991028648862848_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000016772375644138380130000002282030205815866277_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000035501796843659732180000010192058454289485453_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000006678963903168674820000009052192719350905728_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000035501796843659732180000010192058454289485453_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000006678963903168674820000009052192719350905728_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "771",
                                                                      y: "670.8",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000029033907986689582760000007674264769911204253_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000022550229782718643120000013444563203113534632_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000029033907986689582760000007674264769911204253_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000022550229782718643120000013444563203113534632_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000139999231406161441230000006319248221078358703_",
                                                                points:
                                                                  "773.1,672.9 773.9,674.1\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t773.9,673.7 773.5,672.5 773.1,672.9 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000127727898510359359490000003974832537885852607_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000139999231406161441230000006319248221078358703_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000127727898510359359490000003974832537885852607_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000156583114398286670610000009621192055779902342_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000018940665538126565570000012943458113000897701_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000156583114398286670610000009621192055779902342_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000018940665538126565570000012943458113000897701_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "771",
                                                                      y: "670.4",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "6.2",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000145764189689760052090000004401973104023929534_",
                                                        x: "770.6",
                                                        y: "670.4",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000144332282420768055020000000106738208249243008_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000145764189689760052090000004401973104023929534_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000144332282420768055020000000106738208249243008_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("path", {
                                                              attrs: {
                                                                id: "SVGID_00000066507563607334550510000006453220020982326460_",
                                                                d: "M773.5,672.5l0.8,1.2c0-0.8,0-1.2-0.4-2.1\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tl-0.8-0.8C773.1,671.2,773.5,672.1,773.5,672.5",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000114055460990733823300000001349052779523779983_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000066507563607334550510000006453220020982326460_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000114055460990733823300000001349052779523779983_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000097472914413389028440000001758665863491609513_",
                                                                        x: "770.6",
                                                                        y: "670.4",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000102530886263955877690000004075128010810283649_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000097472914413389028440000001758665863491609513_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000102530886263955877690000004075128010810283649_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "770.6",
                                                                      y: "668.3",
                                                                      width:
                                                                        "5.8",
                                                                      height:
                                                                        "7.5",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000167369760183813628220000005226869105770753196_",
                                      d: "M562.1,722.6c0.4,0.4,0.4,0.4,0.8,0.8\n\t\t\t\t\t\ts0.8,0.8,1.7,1.2l-0.4-0.8C562.9,723.5,562.5,723,562.1,722.6",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000047055599672281928870000016983381555911351697_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000167369760183813628220000005226869105770753196_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000047055599672281928870000016983381555911351697_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000054234205293244120500000012949898755827148698_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000141435496426347736530000007840009771607807882_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000054234205293244120500000012949898755827148698_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000141435496426347736530000007840009771607807882_)",
                                              "enable-background": "new",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000000189670993848506730000009351948170196161925_",
                                                        x: "561.3",
                                                        y: "721.8",
                                                        width: "4.6",
                                                        height: "4.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000089533866547502188380000004397438178146833333_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000000189670993848506730000009351948170196161925_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000089533866547502188380000004397438178146833333_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000152985768032683780340000012629442775946168454_",
                                                                points:
                                                                  "562.1,722.6 562.5,723.5\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t562.9,723.9 562.1,722.6 562.1,722.6 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000096025406712296106890000012266829289611344551_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000152985768032683780340000012629442775946168454_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000096025406712296106890000012266829289611344551_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000013893351542882745740000006514635999176032697_",
                                                                        x: "561.3",
                                                                        y: "721.8",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "4.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000070090516453586780780000016332992082213520013_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000013893351542882745740000006514635999176032697_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000070090516453586780780000016332992082213520013_)",
                                                                        fill: "#306175",
                                                                      },
                                                                    attrs: {
                                                                      x: "559.6",
                                                                      y: "720.1",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000174574922830630715980000000140209454923299492_",
                                                        x: "561.3",
                                                        y: "721.8",
                                                        width: "4.6",
                                                        height: "4.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000142860462479834930560000001422047276646592914_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000174574922830630715980000000140209454923299492_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000142860462479834930560000001422047276646592914_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("path", {
                                                              attrs: {
                                                                id: "SVGID_00000015343341093388757090000017609052135715071932_",
                                                                d: "M562.1,722.6l0.8,0.8l0.4,0.4l-0.4-0.8\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tC562.5,723,562.5,723,562.1,722.6",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000072976070709172184080000008185856230149071754_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000015343341093388757090000017609052135715071932_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000072976070709172184080000008185856230149071754_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000086691839354603912240000007857834554584231575_",
                                                                        x: "561.3",
                                                                        y: "721.8",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "4.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000046335617054311313410000016873243960821132713_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000086691839354603912240000007857834554584231575_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000046335617054311313410000016873243960821132713_)",
                                                                        fill: "#32657A",
                                                                      },
                                                                    attrs: {
                                                                      x: "560",
                                                                      y: "720.6",
                                                                      width:
                                                                        "5.8",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000100354002119237862060000013504292443493951659_",
                                                        x: "561.3",
                                                        y: "721.8",
                                                        width: "4.6",
                                                        height: "4.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000055698585096933707710000017366325880579404176_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000100354002119237862060000013504292443493951659_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000055698585096933707710000017366325880579404176_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("path", {
                                                              attrs: {
                                                                id: "SVGID_00000023993773935686534490000013416786826856944788_",
                                                                d: "M562.9,723.5l0.4,0.8l0.4,0.4l-0.4-0.8\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tC563.3,723.5,562.9,723.5,562.9,723.5",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000031170715761036299110000018146207969156235431_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000023993773935686534490000013416786826856944788_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000031170715761036299110000018146207969156235431_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000085936290065231897170000018220835796897671324_",
                                                                        x: "561.3",
                                                                        y: "721.8",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "4.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000026136864274910767890000008080918596371197079_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000085936290065231897170000018220835796897671324_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000026136864274910767890000008080918596371197079_)",
                                                                        fill: "#34697F",
                                                                      },
                                                                    attrs: {
                                                                      x: "560.4",
                                                                      y: "721",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000133492973939094898720000000376493918521355936_",
                                                        x: "561.3",
                                                        y: "721.8",
                                                        width: "4.6",
                                                        height: "4.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000155827234824935260700000001083608233394559388_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000133492973939094898720000000376493918521355936_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000155827234824935260700000001083608233394559388_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000150796526643277350740000000027065672738625680_",
                                                                points:
                                                                  "563.3,723.9 564.2,724.7\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t564.2,724.7 563.7,723.9 563.3,723.9 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000029045462629085784540000010903774782073615251_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000150796526643277350740000000027065672738625680_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000029045462629085784540000010903774782073615251_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000183245485977479523760000008613855685687535777_",
                                                                        x: "561.3",
                                                                        y: "721.8",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "4.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000156585308337232315510000014291360011509858484_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000183245485977479523760000008613855685687535777_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000156585308337232315510000014291360011509858484_)",
                                                                        fill: "#366C82",
                                                                      },
                                                                    attrs: {
                                                                      x: "561.3",
                                                                      y: "721.4",
                                                                      width:
                                                                        "5",
                                                                      height:
                                                                        "5.4",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000033360352853794828220000009565325232857152181_",
                                      d: "M563.7,719.3c-0.4-0.4-0.8-0.4-0.8-0.8l0,0\n\t\t\t\t\t\tc-0.4-0.4-0.4-0.4-0.8-0.8l0,0c0-0.4-0.4-0.4-0.4-0.8l0,0c0-0.4,0-0.4,0-0.8v4.6v0.4v0.4l0,0l0,0v0.4v0.4l0,0l0,0l0,0v0.4\n\t\t\t\t\t\tl0.4,0.4l0,0l0,0l0,0h0.4h0.4h0.4l0,0L563.7,719.3",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000044857227977421947360000009960973289168277695_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000033360352853794828220000009565325232857152181_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000044857227977421947360000009960973289168277695_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000091731939437376263850000009796443562923084161_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000027595261643961813390000012092478977023534772_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000091731939437376263850000009796443562923084161_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000027595261643961813390000012092478977023534772_)",
                                              "enable-background": "new",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000145751102148415842430000015688110498800547716_",
                                                        x: "561.3",
                                                        y: "715.2",
                                                        width: "4.6",
                                                        height: "8.7",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000097499090950500060470000009707565521267856802_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000145751102148415842430000015688110498800547716_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000097499090950500060470000009707565521267856802_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("path", {
                                                              attrs: {
                                                                id: "SVGID_00000090996194548284927620000006803312798860436362_",
                                                                d: "M563.7,719.3c-0.4-0.4-0.8-0.4-0.8-0.8l0,0\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tc-0.4-0.4-0.4-0.4-0.8-0.8l0,0c0-0.4-0.4-0.4-0.4-0.8l0,0c0-0.4,0-0.4,0-0.8v4.6v0.4v0.4l0,0l0,0v0.4v0.4l0,0l0,0\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tl0,0v0.4l0.4,0.4l0,0l0,0l0,0h0.4h0.4h0.4l0,0L563.7,719.3",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000037679597611288219930000008391137535429533609_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000090996194548284927620000006803312798860436362_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000037679597611288219930000008391137535429533609_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000040538253633981747260000014834662837807524019_",
                                                                        x: "561.3",
                                                                        y: "715.2",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "8.7",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000026157867848305765420000017166686072893535126_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000040538253633981747260000014834662837807524019_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          opacity:
                                                                            "0",
                                                                          "clip-path":
                                                                            "url(#SVGID_00000026157867848305765420000017166686072893535126_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "g",
                                                                        {
                                                                          staticClass:
                                                                            "st5",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "g",
                                                                            [
                                                                              _c(
                                                                                "g",
                                                                                [
                                                                                  _c(
                                                                                    "g",
                                                                                    [
                                                                                      _c(
                                                                                        "defs",
                                                                                        [
                                                                                          _c(
                                                                                            "rect",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  id: "SVGID_00000111162039309142735270000005314663435041017741_",
                                                                                                  x: "561.3",
                                                                                                  y: "715.2",
                                                                                                  width:
                                                                                                    "4.6",
                                                                                                  height:
                                                                                                    "8.7",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "clipPath",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              id: "SVGID_00000064324996304065107010000013000555839888066474_",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "use",
                                                                                            {
                                                                                              staticStyle:
                                                                                                {
                                                                                                  overflow:
                                                                                                    "visible",
                                                                                                },
                                                                                              attrs:
                                                                                                {
                                                                                                  "xlink:href":
                                                                                                    "#SVGID_00000111162039309142735270000005314663435041017741_",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000114787915617630807840000002686238622595525562_",
                                                                        x: "561.3",
                                                                        y: "715.2",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "8.7",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000012465696016577079210000016859726483350042281_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000114787915617630807840000002686238622595525562_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "clip-path":
                                                                            "url(#SVGID_00000012465696016577079210000016859726483350042281_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c("g", [
                                                                        _c(
                                                                          "g",
                                                                          [
                                                                            _c(
                                                                              "g",
                                                                              [
                                                                                _c(
                                                                                  "defs",
                                                                                  [
                                                                                    _c(
                                                                                      "rect",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            id: "SVGID_00000120521186396933356000000000465326605849958294_",
                                                                                            x: "561.3",
                                                                                            y: "715.2",
                                                                                            width:
                                                                                              "4.6",
                                                                                            height:
                                                                                              "8.7",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "clipPath",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        id: "SVGID_00000107550333791781825610000000830217919923093175_",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "use",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            overflow:
                                                                                              "visible",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            "xlink:href":
                                                                                              "#SVGID_00000120521186396933356000000000465326605849958294_",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000173143331712574826920000007086686026122953401_",
                                      d: "M562.5,713.5L562.5,713.5L562.5,713.5L562.5,713.5\n\t\t\t\t\t\tL562.5,713.5L562.5,713.5L562.5,713.5l-0.4,0.4l0,0l0,0l0,0l0,0l0,0l0,0c-1.2,1.7-0.4,3.7,1.7,5l0.4-1.2\n\t\t\t\t\t\tC562.1,716.8,561.7,714.8,562.5,713.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000152259013135920248080000014926695382100325788_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000173143331712574826920000007086686026122953401_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000152259013135920248080000014926695382100325788_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000027594573794994705710000010449591021317857467_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000140707893163316247000000007652746448603474842_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000027594573794994705710000010449591021317857467_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000140707893163316247000000007652746448603474842_)",
                                            fill: "#3FB994",
                                          },
                                          attrs: {
                                            x: "558.4",
                                            y: "711",
                                            width: "7.9",
                                            height: "10.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000070808245625417199910000011773339644230455473_",
                                      d: "M562.5,713.5L562.5,713.5L562.5,713.5L562.5,713.5\n\t\t\t\t\t\tL562.5,713.5L562.5,713.5L562.5,713.5l-0.4,0.4l0,0l0,0l0,0l0,0l0,0l0,0c-1.2,1.7-0.4,3.7,1.7,5l0.4-1.2\n\t\t\t\t\t\tC562.1,716.8,561.7,714.8,562.5,713.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000160875413253772186660000002047278561605945772_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000070808245625417199910000011773339644230455473_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000160875413253772186660000002047278561605945772_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000000209589860078390140000014213324815551295410_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000132058848528248698180000006947966797370832547_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000000209589860078390140000014213324815551295410_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000132058848528248698180000006947966797370832547_)",
                                              "enable-background": "new",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000157291469479340941230000006496562622720693180_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000034772081490418627860000010972317807413074354_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000157291469479340941230000006496562622720693180_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000034772081490418627860000010972317807413074354_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("path", {
                                                              attrs: {
                                                                id: "SVGID_00000106143678802167525770000001619245226108489112_",
                                                                d: "M562.5,713.5l-0.8,0.8\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tc-0.4,0.4-0.4,0.8-0.4,0.8l0.8-0.8C562.1,713.9,562.5,713.9,562.5,713.5",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000049199851374664821430000005941018227870713016_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000106143678802167525770000001619245226108489112_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000049199851374664821430000005941018227870713016_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000099650770097962410110000016924377219721932956_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000013884976640033437940000010509428173735701680_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000099650770097962410110000016924377219721932956_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000013884976640033437940000010509428173735701680_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "559.2",
                                                                      y: "711",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "6.2",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000041267919349646778150000005441710785041042571_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000049936143893948703190000013250746729126123400_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000041267919349646778150000005441710785041042571_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000049936143893948703190000013250746729126123400_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000090996058568909874520000014634648635884377746_",
                                                                points:
                                                                  "562.1,714.3 561.3,715.2\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t561.3,716 562.1,714.8 562.1,714.3 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000170267355784489971370000012213616952586320008_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000090996058568909874520000014634648635884377746_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000170267355784489971370000012213616952586320008_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000009560277374848936760000011014917411758288830_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000129186754190744541480000009000819865767826610_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000009560277374848936760000011014917411758288830_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000129186754190744541480000009000819865767826610_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "559.2",
                                                                      y: "712.3",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000105406279499429613710000006590214213971434151_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000032628894351521459980000010316877322526485408_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000105406279499429613710000006590214213971434151_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000032628894351521459980000010316877322526485408_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000109735145101767304830000017750328347611854780_",
                                                                points:
                                                                  "562.1,714.8 561.3,716\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t561.3,716.4 562.1,715.2 562.1,714.8 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000097498897082012409760000007620327042775024789_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000109735145101767304830000017750328347611854780_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000097498897082012409760000007620327042775024789_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000142171082038744188730000009772455584472062349_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000103230001153430374370000008098788359652078217_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000142171082038744188730000009772455584472062349_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000103230001153430374370000008098788359652078217_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "559.2",
                                                                      y: "712.7",
                                                                      width:
                                                                        "5",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000061459062012704236690000006383217725734584501_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000115485953083038181730000016364189124934625687_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000061459062012704236690000006383217725734584501_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000115485953083038181730000016364189124934625687_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000166642647953792309080000007292878295616588695_",
                                                                points:
                                                                  "562.1,715.2 561.3,716.4\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t561.3,716.4 562.1,715.6 562.1,715.2 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000096052295654485653490000010240287077824078781_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000166642647953792309080000007292878295616588695_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000096052295654485653490000010240287077824078781_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000107575514491476963510000005149960721418233247_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000113324543246129544630000013568420998881516691_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000107575514491476963510000005149960721418233247_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000113324543246129544630000013568420998881516691_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "559.2",
                                                                      y: "713.1",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000158019733466491992950000001926332060655773885_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000034803056879758907330000014086140496532017339_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000158019733466491992950000001926332060655773885_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000034803056879758907330000014086140496532017339_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000174581883449591639890000000765190998208180368_",
                                                                points:
                                                                  "562.1,715.6 561.3,716.4\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t561.3,716.8 562.1,715.6 562.1,715.6 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000088821255017562480510000007607539739116728747_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000174581883449591639890000000765190998208180368_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000088821255017562480510000007607539739116728747_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000061434222570741657350000013822753879322890898_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000146465923919660581110000018262746262365799076_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000061434222570741657350000013822753879322890898_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000146465923919660581110000018262746262365799076_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "559.2",
                                                                      y: "713.1",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000070115729800976342740000018011535984065022396_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000178887744065733746010000007081256860131074477_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000070115729800976342740000018011535984065022396_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000178887744065733746010000007081256860131074477_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000145027910591670133630000009040725655333427859_",
                                                                points:
                                                                  "562.1,715.6 561.3,716.8\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t561.7,717.2 562.1,716 562.1,715.6 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000083082024932717703390000001020474431399640450_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000145027910591670133630000009040725655333427859_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000083082024932717703390000001020474431399640450_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000133527560742744731730000001347314896092860836_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000127746698524953669810000005091058509436077994_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000133527560742744731730000001347314896092860836_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000127746698524953669810000005091058509436077994_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "559.2",
                                                                      y: "713.5",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000016072127288295474690000009968147157260151480_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000127765767327546315060000008088592792499696563_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000016072127288295474690000009968147157260151480_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000127765767327546315060000008088592792499696563_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000076578407878284219850000014195523172707061128_",
                                                                points:
                                                                  "562.1,716 561.7,717.2\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t561.7,717.2 562.1,716 562.1,716 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000067223916496437202940000015074723032095837319_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000076578407878284219850000014195523172707061128_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000067223916496437202940000015074723032095837319_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000038388614395542262250000013254033791033769879_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000086684410585552185010000015546268638355575964_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000038388614395542262250000013254033791033769879_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000086684410585552185010000015546268638355575964_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "559.2",
                                                                      y: "713.5",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000137813103818377773280000005754403587616261303_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000171691755609259958600000002483222406713836471_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000137813103818377773280000005754403587616261303_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000171691755609259958600000002483222406713836471_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000077303515172161481360000001072029597413738934_",
                                                                points:
                                                                  "562.1,716 561.7,717.2\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t561.7,717.7 562.5,716.4 562.1,716 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000092437775394233243280000009196279391678021523_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000077303515172161481360000001072029597413738934_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000092437775394233243280000009196279391678021523_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000011001314870295476230000013949936516014758569_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000012458805124534223340000006010035386182688181_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000011001314870295476230000013949936516014758569_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000012458805124534223340000006010035386182688181_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "559.2",
                                                                      y: "713.9",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000163066353063884981710000013184979338723843509_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000163067477057518576720000014717721729797672065_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000163066353063884981710000013184979338723843509_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000163067477057518576720000014717721729797672065_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000147935396049826292780000008501147009618660533_",
                                                                points:
                                                                  "562.5,716.4 561.7,717.7\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t561.7,717.7 562.5,716.4 562.5,716.4 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000147194140065772973190000010560540861886108573_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000147935396049826292780000008501147009618660533_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000147194140065772973190000010560540861886108573_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000096059860538897661800000015557043272623256485_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000054264597046761617240000017777333403030551476_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000096059860538897661800000015557043272623256485_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000054264597046761617240000017777333403030551476_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "559.6",
                                                                      y: "713.9",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000176033284996025914020000013395395084765213363_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000021807703782801998600000017017171712735125134_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000176033284996025914020000013395395084765213363_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000021807703782801998600000017017171712735125134_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000137107134549060300130000010339328900960782743_",
                                                                points:
                                                                  "562.5,716.4 561.7,717.7\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t562.1,718.1 562.5,716.8 562.5,716.4 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000037690213059840012220000010201758345619756689_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000137107134549060300130000010339328900960782743_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000037690213059840012220000010201758345619756689_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000153664607727338439860000014869315533050649018_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000101813380336778684860000016204818133285232537_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000153664607727338439860000014869315533050649018_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000101813380336778684860000016204818133285232537_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "559.6",
                                                                      y: "714.3",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000177454714142543936000000013364006160656609210_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000177459758220615132850000015707857951455930248_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000177454714142543936000000013364006160656609210_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000177459758220615132850000015707857951455930248_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000083804336201905743880000005373858492609239448_",
                                                                points:
                                                                  "562.5,716.8 562.1,718.1\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t562.1,718.1 562.9,716.8 562.5,716.8 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000000932525152397634700000016777329218700168838_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000083804336201905743880000005373858492609239448_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000000932525152397634700000016777329218700168838_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000139271387492581220320000014282607950557971344_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000130612727597091159500000003503696823988031128_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000139271387492581220320000014282607950557971344_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000130612727597091159500000003503696823988031128_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "559.6",
                                                                      y: "714.3",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000114781286734315879580000006061427401953379464_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000134233466483341193440000008240817206331981752_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000114781286734315879580000006061427401953379464_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000134233466483341193440000008240817206331981752_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000131345763505077158360000010543364024007489425_",
                                                                points:
                                                                  "562.9,716.8 562.1,718.1\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t562.5,718.5 562.9,716.8 562.9,716.8 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000038399050637732243340000012998236910975169188_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000131345763505077158360000010543364024007489425_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000038399050637732243340000012998236910975169188_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000152977976240968154370000013393099915258689450_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000089561349063323064730000012455583973394067094_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000152977976240968154370000013393099915258689450_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000089561349063323064730000012455583973394067094_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "560",
                                                                      y: "714.8",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000070107403190191124270000017213392282254475452_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000003071789558368416160000007142918719306302088_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000070107403190191124270000017213392282254475452_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000003071789558368416160000007142918719306302088_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000060716108868922257610000015989221388376873884_",
                                                                points:
                                                                  "562.9,716.8 562.5,718.5\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t562.5,718.5 562.9,717.2 562.9,716.8 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000157281393325392406180000015609745390086389668_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000060716108868922257610000015989221388376873884_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000157281393325392406180000015609745390086389668_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000152249779610114848240000013594703905959688843_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000152942518320201226350000010023489067891447957_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000152249779610114848240000013594703905959688843_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000152942518320201226350000010023489067891447957_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "560",
                                                                      y: "714.8",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000152950373927057205330000007661681060990366085_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000113341150122120269350000014240305800554118843_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000152950373927057205330000007661681060990366085_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000113341150122120269350000014240305800554118843_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000121259699075813657700000001118224359000348039_",
                                                                points:
                                                                  "562.9,717.2 562.5,718.5\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t562.9,718.5 563.3,717.2 562.9,717.2 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000075857765431576420230000017633206299360958896_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000121259699075813657700000001118224359000348039_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000075857765431576420230000017633206299360958896_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000156585402380423398820000004783220248057634731_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000061469309392842661920000002984263499425450668_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000156585402380423398820000004783220248057634731_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000061469309392842661920000002984263499425450668_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "560.4",
                                                                      y: "715.2",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000089555458218675492550000000306218758182994608_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000134243825712631558680000005876551765662134691_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000089555458218675492550000000306218758182994608_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000134243825712631558680000005876551765662134691_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000054983441671361703730000013571816448020237965_",
                                                                points:
                                                                  "563.3,717.2 562.9,718.5\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t562.9,718.9 563.3,717.7 563.3,717.2 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000020399361679967650080000008188159679253529002_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000054983441671361703730000013571816448020237965_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000020399361679967650080000008188159679253529002_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000083801929653621202550000002885716756382064553_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000171705735471828780710000007175843332284786820_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000083801929653621202550000002885716756382064553_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000171705735471828780710000007175843332284786820_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "560.4",
                                                                      y: "715.2",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000044143485283476459970000016784721654574846878_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000072265797603761781220000009572102655662863779_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000044143485283476459970000016784721654574846878_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000072265797603761781220000009572102655662863779_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000178175715699821146000000013845833998281190273_",
                                                                points:
                                                                  "563.3,717.7 562.9,718.9\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t563.3,718.9 563.7,717.7 563.3,717.7 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000005986146101971642520000003822669385759636864_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000178175715699821146000000013845833998281190273_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000005986146101971642520000003822669385759636864_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000069388976694370465240000005390108289490327686_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000099646033975246900900000009887394353583725985_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000069388976694370465240000005390108289490327686_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000099646033975246900900000009887394353583725985_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "560.8",
                                                                      y: "715.2",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000145767734618676244610000009932211683970362298_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000151534943993661669060000012915799150295323310_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000145767734618676244610000009932211683970362298_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000151534943993661669060000012915799150295323310_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000167389550249176241770000003123917873638182564_",
                                                                points:
                                                                  "563.7,717.7 563.3,718.9\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t563.3,719.3 563.7,717.7 563.7,717.7 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000103978327763587025820000013304197748512988831_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000167389550249176241770000003123917873638182564_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000103978327763587025820000013304197748512988831_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000115516480716164741260000009515086214972054675_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000080185358166389541060000012347213779559778182_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000115516480716164741260000009515086214972054675_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000080185358166389541060000012347213779559778182_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "560.8",
                                                                      y: "715.6",
                                                                      width:
                                                                        "5.4",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000123419862538018759510000001942316979902468736_",
                                                        x: "561.3",
                                                        y: "712.7",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000021840448236398196040000013110772788023616413_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000123419862538018759510000001942316979902468736_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000021840448236398196040000013110772788023616413_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000011019578085008221250000000876594063751762563_",
                                                                points:
                                                                  "563.7,717.7 563.3,719.3\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t563.7,719.3 564.2,717.7 563.7,717.7 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000169534380256909175760000002019353489798711947_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000011019578085008221250000000876594063751762563_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000169534380256909175760000002019353489798711947_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000010301103488879566610000002527227978360818586_",
                                                                        x: "558.8",
                                                                        y: "712.7",
                                                                        width:
                                                                          "6.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000078747214065808089630000015333904107137266079_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000010301103488879566610000002527227978360818586_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000078747214065808089630000015333904107137266079_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "561.3",
                                                                      y: "715.6",
                                                                      width:
                                                                        "5",
                                                                      height:
                                                                        "5.8",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000068647378876559000770000001650058729069464466_",
                                      d: "M772.3,680.8L772.3,680.8l-133.1,79.2\n\t\t\t\t\t\tc-0.4,0.4-0.8,0.4-1.2,0.4l0,0c-0.4,0-0.8,0.4-1.2,0.4h-0.4c-0.4,0-0.8,0-1.2,0.4l0,0l0,0c-0.8,0-1.2,0-2.1,0h-0.4\n\t\t\t\t\t\tc-0.8,0-1.2,0-2.1-0.4c-0.4,0-0.8,0-1.2-0.4l0,0c-0.4,0-0.8-0.4-1.2-0.4l-64.7-36.5l0.4,0.8l64.7,36.5l0.4,0.4\n\t\t\t\t\t\tc0,0,0.4,0,0.4,0.4l0,0l0,0c0.4,0,0.4,0,0.8,0.4l0,0c0.4,0,1.2,0.4,1.7,0.4h0.4c0.4,0,1.2,0,1.7,0l0,0l0,0l0,0\n\t\t\t\t\t\tc0.4,0,0.4,0,0.8,0l0,0h0.4h0.4c0.4,0,0.4,0,0.8-0.4l0,0l0,0c0.4,0,0.4,0,0.8-0.4l0.4-0.4L770.2,682c0.4-0.4,1.2-0.8,1.7-1.2\n\t\t\t\t\t\tl0.8-0.8C773.1,680.3,772.7,680.8,772.3,680.8",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000030450208701350671680000016447042327748228762_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000068647378876559000770000001650058729069464466_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000030450208701350671680000016447042327748228762_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000049936385628154840200000017765346674835395971_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000082367077017306216860000014437245141691449258_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000049936385628154840200000017765346674835395971_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000082367077017306216860000014437245141691449258_)",
                                            fill: "#154C3D",
                                          },
                                          attrs: {
                                            x: "561.3",
                                            y: "677.4",
                                            width: "214.3",
                                            height: "87.1",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000121251855418373487180000007346370803607740078_",
                                      points:
                                        "639.2,755.4 639.2,760.4 771.9,681.2\n\t\t\t\t\t\t771.9,676.6 639.2,755.4 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000171706470952693880050000016578525451037734320_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000121251855418373487180000007346370803607740078_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000171706470952693880050000016578525451037734320_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000106855155433015590830000005825956169525686953_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000060737409080696204560000004911314575041405872_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000106855155433015590830000005825956169525686953_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000060737409080696204560000004911314575041405872_)",
                                            fill: "#226A57",
                                          },
                                          attrs: {
                                            x: "636.7",
                                            y: "674.1",
                                            width: "137.2",
                                            height: "88.3",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000065043455484623401270000000273419207693818498_",
                                      points:
                                        "563.7,719.3 563.7,723.9 628.4,760.4\n\t\t\t\t\t\t628.4,755.8 563.7,719.3 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000029737109896297687060000001389709579619295135_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000065043455484623401270000000273419207693818498_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000029737109896297687060000001389709579619295135_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000080925316523657824420000007119625797057471658_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000023986146002567659850000004712530044030097835_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000080925316523657824420000007119625797057471658_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000023986146002567659850000004712530044030097835_)",
                                            fill: "#226A57",
                                          },
                                          attrs: {
                                            x: "561.3",
                                            y: "716.8",
                                            width: "69.2",
                                            height: "45.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000111906734398168371580000011604502884523948966_",
                                      points:
                                        "638.4,754.1 639.2,755.4 771.9,676.6\n\t\t\t\t\t\t771.4,675 638.4,754.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000155126087495423846700000010136317225016480166_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000111906734398168371580000011604502884523948966_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000155126087495423846700000010136317225016480166_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000019665937363181058110000015152296777263504261_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000115480395730601808550000001574461084103465658_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000019665937363181058110000015152296777263504261_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000115480395730601808550000001574461084103465658_)",
                                            fill: "#3FB994",
                                          },
                                          attrs: {
                                            x: "636.3",
                                            y: "672.9",
                                            width: "137.6",
                                            height: "85",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000067943026755415762590000003910863759465024419_",
                                      points:
                                        "564.2,717.7 563.7,719.3 628.4,755.8\n\t\t\t\t\t\t628.8,754.1 564.2,717.7 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000179624917666802547540000006131700691282072503_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000067943026755415762590000003910863759465024419_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000179624917666802547540000006131700691282072503_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000014594263493056824940000009190089180060822164_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000072977650030705739450000010688557706473881513_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000014594263493056824940000009190089180060822164_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000072977650030705739450000010688557706473881513_)",
                                            fill: "#3FB994",
                                          },
                                          attrs: {
                                            x: "561.3",
                                            y: "715.6",
                                            width: "69.6",
                                            height: "42.3",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000051377861009528832710000014111560442396024975_",
                                      d: "M628.8,754.1c2.9,1.7,7,1.7,9.9,0L771.4,675\n\t\t\t\t\t\tc2.5-1.7,2.5-4.1,0-5.8l-64.7-36.5c-2.9-1.7-7-1.7-9.9,0l-132.7,79.2c-2.5,1.7-2.5,4.1,0,5.8L628.8,754.1",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000022554206583798360900000009409002609598801843_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000051377861009528832710000014111560442396024975_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000022554206583798360900000009409002609598801843_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000082333005109105846210000013634978787508771769_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000100358076144577776910000007226751336011441312_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000082333005109105846210000013634978787508771769_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000100358076144577776910000007226751336011441312_)",
                                            fill: "#25292A",
                                          },
                                          attrs: {
                                            x: "559.2",
                                            y: "629.4",
                                            width: "217.2",
                                            height: "128.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000160883495166637882950000013418833624546832305_",
                                      d: "M638.4,754.1c-0.4,0-0.8,0.4-1.2,0.4l0,0\n\t\t\t\t\t\tc-0.4,0-0.8,0.4-1.2,0.4l0,0c-0.4,0-0.8,0-1.2,0.4l0,0c-0.4,0-0.8,0-1.2,0l0,0c-0.4,0-0.8,0-1.2,0l0,0c-0.4,0-0.8,0-1.2,0l0,0\n\t\t\t\t\t\tc-0.4,0-0.8-0.4-1.2-0.4l0,0c-0.4,0-0.8-0.4-1.2-0.4v1.2l0,0h0.4h0.4h0.4h0.4l0,0l0,0l0,0l0,0l0,0h0.4l0,0l0,0l0,0l0,0l0,0l0,0\n\t\t\t\t\t\tl0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0.4h0.4h0.4h0.4l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0\n\t\t\t\t\t\tl0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0.4h0.4h0.4h0.4h0.4h0.4h0.4\n\t\t\t\t\t\tl0,0L638.4,754.1",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000026855633583701213090000008768802206111571889_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000160883495166637882950000013418833624546832305_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000026855633583701213090000008768802206111571889_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000008840615431330890380000011181384746636733333_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000050620681310623777780000014544972992163209141_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000008840615431330890380000011181384746636733333_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000050620681310623777780000014544972992163209141_)",
                                            fill: "#3FB994",
                                          },
                                          attrs: {
                                            x: "625.9",
                                            y: "752.1",
                                            width: "15.3",
                                            height: "7",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000039131269212055126780000017187437716791903421_",
                                      d: "M741.2,658.8c-0.4-0.4-0.4-0.4,0-0.8\n\t\t\t\t\t\tc0.4-0.4,1.2-0.4,1.7,0c0.4,0.4,0.4,0.4,0,0.8C742.4,659.2,741.6,659.2,741.2,658.8 M743.3,658c-0.4-0.4-1.7-0.4-2.1,0\n\t\t\t\t\t\tc-0.4,0.4-0.4,0.8,0,1.2c0.4,0.4,1.7,0.4,2.1,0C743.7,658.8,743.7,658,743.3,658",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000055695851147677268390000001973825822255799977_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000039131269212055126780000017187437716791903421_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000055695851147677268390000001973825822255799977_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000070808125805515118560000008960034333561831344_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000173154247311690207770000001084897209368260762_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000070808125805515118560000008960034333561831344_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000173154247311690207770000001084897209368260762_)",
                                            fill: "#42B994",
                                          },
                                          attrs: {
                                            x: "738.3",
                                            y: "655.1",
                                            width: "7.9",
                                            height: "6.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000059988021996407023340000017967914032614133680_",
                                      d: "M742.8,658c0.4,0.4,0.4,0.4,0,0.8\n\t\t\t\t\t\tc-0.4,0.4-1.2,0.4-1.7,0c-0.4-0.4-0.4-0.4,0-0.8C741.6,658,742.4,657.5,742.8,658",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000165916474898108156370000009663939431045892797_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000059988021996407023340000017967914032614133680_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000165916474898108156370000009663939431045892797_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000152223151456493649660000002310160048292184475_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000079477427546325464920000015235243455888757660_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000152223151456493649660000002310160048292184475_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000079477427546325464920000015235243455888757660_)",
                                            fill: "#25292A",
                                          },
                                          attrs: {
                                            x: "738.7",
                                            y: "655.5",
                                            width: "6.6",
                                            height: "5.8",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000014631858176554317950000004261183276049615039_",
                                      d: "M738.3,657.1c-0.4-0.4-0.4-0.4,0-0.8\n\t\t\t\t\t\tc0.4-0.4,1.2-0.4,1.7,0c0.4,0.4,0.4,0.4,0,0.8C739.5,657.5,738.7,657.5,738.3,657.1 M739.9,656.3c-0.4-0.4-1.7-0.4-2.1,0\n\t\t\t\t\t\tc-0.4,0.4-0.4,0.8,0,1.2c0.4,0.4,1.7,0.4,2.1,0C740.8,657.1,740.8,656.3,739.9,656.3",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000002380229849754003940000009355808075419307145_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000014631858176554317950000004261183276049615039_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000002380229849754003940000009355808075419307145_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000087413978276914643480000010813985401964213686_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000012441202077179201070000014649658041877810847_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000087413978276914643480000010813985401964213686_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000012441202077179201070000014649658041877810847_)",
                                            fill: "#42B994",
                                          },
                                          attrs: {
                                            x: "735.4",
                                            y: "653.4",
                                            width: "7.9",
                                            height: "6.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000041979035364793818810000004230276958618244235_",
                                      d: "M739.9,656.3c0.4,0.4,0.4,0.4,0,0.8\n\t\t\t\t\t\tc-0.4,0.4-1.2,0.4-1.7,0c-0.4-0.4-0.4-0.4,0-0.8C738.7,656.3,739.5,655.9,739.9,656.3",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000045599913522660793010000015539205974076449198_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000041979035364793818810000004230276958618244235_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000045599913522660793010000015539205974076449198_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000031913252035877198820000016760871669316098467_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000019662886148471452220000009375602030807247292_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000031913252035877198820000016760871669316098467_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000019662886148471452220000009375602030807247292_)",
                                            fill: "#25292A",
                                          },
                                          attrs: {
                                            x: "735.8",
                                            y: "653.8",
                                            width: "6.6",
                                            height: "5.8",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000176000699537455186250000008888589630036429963_",
                                      d: "M734.5,655.1l-8.3-4.6c-0.4,0-0.4-0.4,0-0.4l0.4-0.4\n\t\t\t\t\t\tc0.4,0,0.8,0,0.8,0l8.3,4.6c0.4,0,0.4,0.4,0,0.4l-0.4,0.4C735,655.1,734.5,655.1,734.5,655.1 M727.5,649.3c-0.4,0-0.8,0-0.8,0\n\t\t\t\t\t\tl-1.2,0.8c-0.4,0-0.4,0.4,0,0.4l9.1,5c0.4,0,0.8,0,0.8,0l1.2-0.8c0.4,0,0.4-0.4,0-0.4L727.5,649.3",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000171713344131111338930000011284542154460614282_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000176000699537455186250000008888589630036429963_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000171713344131111338930000011284542154460614282_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000005958038607541919540000012442608757488730814_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000121980997608417612050000015629147260117847945_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000005958038607541919540000012442608757488730814_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000121980997608417612050000015629147260117847945_)",
                                            fill: "#42B994",
                                          },
                                          attrs: {
                                            x: "722.9",
                                            y: "646.8",
                                            width: "16.2",
                                            height: "11.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000177453518778310552440000004607476099132556434_",
                                      d: "M727.5,649.3l8.3,4.6c0.4,0,0.4,0.4,0,0.4l-0.4,0.4\n\t\t\t\t\t\tc-0.4,0-0.8,0-0.8,0l-8.3-4.6c-0.4,0-0.4-0.4,0-0.4l0.4-0.4C727.1,649.3,727.5,649.3,727.5,649.3",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000135672340829317833990000003208720782637014424_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000177453518778310552440000004607476099132556434_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000135672340829317833990000003208720782637014424_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000147193597430127451330000004143404969204143493_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000165944635450141442260000010582984103724737178_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000147193597430127451330000004143404969204143493_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000165944635450141442260000010582984103724737178_)",
                                            fill: "#25292A",
                                          },
                                          attrs: {
                                            x: "723.8",
                                            y: "647.2",
                                            width: "14.9",
                                            height: "10.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000107560684304438299470000004231707025087465380_",
                                      points:
                                        "753.2,688.6 725,705.6 725,708.1\n\t\t\t\t\t\t753.2,691.5 753.2,688.6 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000130610144004150992190000006141284675976513168_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000107560684304438299470000004231707025087465380_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000130610144004150992190000006141284675976513168_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000150789180940284952290000018347257927040917921_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000134217244119206646970000003743940838396345749_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000150789180940284952290000018347257927040917921_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000134217244119206646970000003743940838396345749_)",
                                              "enable-background": "new",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000104705743427989984190000003305331074130068613_",
                                                        x: "723.8",
                                                        y: "688.2",
                                                        width: "31.1",
                                                        height: "19.9",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000065781919557458467370000001290634820747938714_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000104705743427989984190000003305331074130068613_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000065781919557458467370000001290634820747938714_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("path", {
                                                              attrs: {
                                                                id: "SVGID_00000057132161013209819780000011143334411031805322_",
                                                                d: "M725,706.9c0-0.8,1.2-2.1,2.5-2.5l11.6-6.6\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tv2.5l-11.6,6.6C725.8,707.3,725,707.7,725,706.9",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000178181153043969518310000003923917778245281412_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000057132161013209819780000011143334411031805322_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000178181153043969518310000003923917778245281412_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000052802213024453638590000014815340984752518286_",
                                                                        x: "723.8",
                                                                        y: "688.2",
                                                                        width:
                                                                          "31.1",
                                                                        height:
                                                                          "19.9",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000075144288444439563630000017985416655389166007_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000052802213024453638590000014815340984752518286_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000075144288444439563630000017985416655389166007_)",
                                                                        fill: "#25292A",
                                                                      },
                                                                    attrs: {
                                                                      x: "722.5",
                                                                      y: "695.3",
                                                                      width:
                                                                        "18.2",
                                                                      height:
                                                                        "14.5",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000160893495405150239430000011925837227409419690_",
                                                        x: "723.8",
                                                        y: "688.2",
                                                        width: "31.1",
                                                        height: "19.9",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000054975283804797543450000000235665381101009846_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000160893495405150239430000011925837227409419690_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000054975283804797543450000000235665381101009846_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("path", {
                                                              attrs: {
                                                                id: "SVGID_00000021800204939377854870000013611824776591007659_",
                                                                d: "M739.5,699.4v-2.5l11.6-6.6\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tc1.2-0.8,2.5-0.8,2.5,0s-1.2,2.1-2.5,2.5L739.5,699.4",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000029015789127690494840000010924794039814181804_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000021800204939377854870000013611824776591007659_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000029015789127690494840000010924794039814181804_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000070111987891975231980000004427553516652923283_",
                                                                        x: "723.8",
                                                                        y: "688.2",
                                                                        width:
                                                                          "31.1",
                                                                        height:
                                                                          "19.9",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000031886036187331510170000007548822278729760130_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000070111987891975231980000004427553516652923283_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000031886036187331510170000007548822278729760130_)",
                                                                        fill: "#25292A",
                                                                      },
                                                                    attrs: {
                                                                      x: "737",
                                                                      y: "687",
                                                                      width:
                                                                        "18.2",
                                                                      height:
                                                                        "14.5",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000146465329264869204920000003706408945559080585_",
                                      points:
                                        "611,746.3 611,750.4 614.3,752.5\n\t\t\t\t\t\t614.3,748.3 611,746.3 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000112613939532190637210000005351769609696604052_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000146465329264869204920000003706408945559080585_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000112613939532190637210000005351769609696604052_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000145057912299812976790000011965618640677530523_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000086693737562437577130000007024223479389005503_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000145057912299812976790000011965618640677530523_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000086693737562437577130000007024223479389005503_)",
                                              "enable-background": "new",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000157268692046361225280000005389918499599319710_",
                                                        x: "610.2",
                                                        y: "746.3",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000147915020614796146250000003975831788109959089_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000157268692046361225280000005389918499599319710_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000147915020614796146250000003975831788109959089_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("path", {
                                                              attrs: {
                                                                id: "SVGID_00000042717774486364799350000006480452642581231774_",
                                                                d: "M612.7,747.9c0.8,0.4,1.7,1.7,1.7,2.5\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tc0,0.8-0.8,1.2-1.2,0.8c-0.8-0.4-1.7-1.7-1.7-2.5S611.8,747.1,612.7,747.9 M612.7,751.2c0.8,0.4,1.7,0,1.7-0.8\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tc0-1.2-0.8-2.5-1.7-2.9s-1.7,0-1.7,0.8C611,749.6,611.8,750.8,612.7,751.2",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000001655784740443970570000008180158917746421639_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000042717774486364799350000006480452642581231774_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000001655784740443970570000008180158917746421639_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000044859784237536360550000007343471757755028665_",
                                                                        x: "610.2",
                                                                        y: "746.3",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000182515441827620293060000011935615450889205155_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000044859784237536360550000007343471757755028665_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000182515441827620293060000011935615450889205155_)",
                                                                        fill: "#3FB994",
                                                                      },
                                                                    attrs: {
                                                                      x: "608.9",
                                                                      y: "744.6",
                                                                      width:
                                                                        "7.9",
                                                                      height:
                                                                        "9.5",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000116204229576950013100000006236374003361237416_",
                                                        x: "610.2",
                                                        y: "746.3",
                                                        width: "4.6",
                                                        height: "6.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000160905981513326146080000002142684949095249544_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000116204229576950013100000006236374003361237416_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000160905981513326146080000002142684949095249544_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("path", {
                                                              attrs: {
                                                                id: "SVGID_00000071527706914812503610000018206159658933717671_",
                                                                d: "M612.7,750.8c-0.8-0.4-1.7-1.7-1.7-2.5\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ts0.8-1.2,1.2-0.8c0.8,0.4,1.7,1.7,1.7,2.5C614.3,751.2,613.5,751.7,612.7,750.8",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000161594305530610922320000008418148863214028972_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000071527706914812503610000018206159658933717671_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000161594305530610922320000008418148863214028972_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000116234330858827104800000012992802032418017687_",
                                                                        x: "610.2",
                                                                        y: "746.3",
                                                                        width:
                                                                          "4.6",
                                                                        height:
                                                                          "6.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000159432514625394333110000008989392822890916490_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000116234330858827104800000012992802032418017687_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("rect", {
                                                                    staticStyle:
                                                                      {
                                                                        "clip-path":
                                                                          "url(#SVGID_00000159432514625394333110000008989392822890916490_)",
                                                                        fill: "#001820",
                                                                      },
                                                                    attrs: {
                                                                      x: "608.9",
                                                                      y: "745",
                                                                      width:
                                                                        "7.5",
                                                                      height:
                                                                        "8.7",
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000095319721413782687730000004157257362051386047_",
                                      d: "M487.5,566.3V614c0,10.4,5.8,20.3,14.5,25.7l29,16.6\n\t\t\t\t\t\tl85-49.3l-29-15.8c-9.1-5.4-14.9-14.9-14.9-25.7v-47.7L487.5,566.3",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000177476221894328994870000007139990800878459070_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000095319721413782687730000004157257362051386047_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000177476221894328994870000007139990800878459070_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000178911343440760770790000014551618193101418632_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000106120484549942226120000013742654472385412531_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000178911343440760770790000014551618193101418632_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000106120484549942226120000013742654472385412531_)",
                                            fill: "#25292A",
                                          },
                                          attrs: {
                                            x: "485.4",
                                            y: "514.9",
                                            width: "133.1",
                                            height: "143",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000129920693650961032690000000860625646832880017_",
                                      points:
                                        "616.4,596.2 616.4,606.6 531.4,655.9\n\t\t\t\t\t\t531.4,645.5 616.4,596.2 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000145741612507209256280000005583549902531405726_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000129920693650961032690000000860625646832880017_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000145741612507209256280000005583549902531405726_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000032638487157641585290000017517592355493045671_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000173858115314458386770000008152511056187199402_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000032638487157641585290000017517592355493045671_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000173858115314458386770000008152511056187199402_)",
                                            fill: "#25292A",
                                          },
                                          attrs: {
                                            x: "529.3",
                                            y: "593.7",
                                            width: "89.5",
                                            height: "64.3",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000080180493682108375840000015222560775285805474_",
                                      points:
                                        "285.2,689.1 285.2,689.1 285.2,689.1\n\t\t\t\t\t\t285.2,689.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000114773681519480222840000002386504590183853493_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000080180493682108375840000015222560775285805474_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000114773681519480222840000002386504590183853493_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000169539711549856144810000013898099114934897591_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000159467384674599996620000005662091556204796307_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000169539711549856144810000013898099114934897591_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000159467384674599996620000005662091556204796307_)",
                                            fill: "#A4A6A5",
                                          },
                                          attrs: {
                                            x: "282.7",
                                            y: "687",
                                            width: "4.6",
                                            height: "4.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000065050431767198806530000013781628158087201718_",
                                      points:
                                        "285.2,689.1 284.8,688.6 285.2,689.1\n\t\t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000158712660969617785390000005992309167626803587_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000065050431767198806530000013781628158087201718_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000158712660969617785390000005992309167626803587_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000137128242408695935670000002040169084238474408_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000019642398297652565340000001673625634481879221_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000137128242408695935670000002040169084238474408_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000019642398297652565340000001673625634481879221_)",
                                            fill: "#9CB3C6",
                                          },
                                          attrs: {
                                            x: "282.7",
                                            y: "686.6",
                                            width: "5",
                                            height: "4.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000034804441738588687560000008225788150739476926_",
                                      d: "M731.6,67.2l1.7,0.8\n\t\t\t\t\t\tC732.9,67.6,732.1,67.6,731.6,67.2",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000176729665715852029210000013447802795452411570_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000034804441738588687560000008225788150739476926_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000176729665715852029210000013447802795452411570_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000041997938074525599990000009746968935187751049_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000022545281866234052160000001169948870518439570_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000041997938074525599990000009746968935187751049_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000022545281866234052160000001169948870518439570_)",
                                            fill: "#9CB3C6",
                                          },
                                          attrs: {
                                            x: "729.6",
                                            y: "64.7",
                                            width: "6.2",
                                            height: "5.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000065752803545365227460000006872786590431405226_",
                                      d: "M721.3,61c-1.7-1.2-2.9-2.1-5-2.9\n\t\t\t\t\t\tc-2.9-1.2-6.2-1.7-9.5-1.2c-1.7,0-3.3,0.4-4.6,1.2l0,0c-0.8,0.4-1.7,0.8-2.5,1.2l-14.9,8.3l0,0L288.9,291.9l13.7,7.9\n\t\t\t\t\t\tL713.4,67.6c5.8-3.3,12.9-3.3,18.2-0.4L721.3,61",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000149362165278020569720000011671994847894164920_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000065752803545365227460000006872786590431405226_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000149362165278020569720000011671994847894164920_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000060709296731372166130000007620353866477124232_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000176007946694944033030000000641579940701438636_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000060709296731372166130000007620353866477124232_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000176007946694944033030000000641579940701438636_)",
                                            fill: "#25292A",
                                          },
                                          attrs: {
                                            x: "286.8",
                                            y: "54.8",
                                            width: "447.3",
                                            height: "247.5",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000013154879130281639750000013923949413454929086_",
                                      d: "M295.1,303.9c-12.9,7.5-20.7,21.1-20.7,35.7\n\t\t\t\t\t\tl0.8,299.7L742,374.4l0.4-290.2c0-7-3.7-12.9-9.1-16.2l0,0l-1.7-0.8c-5.4-2.9-12-2.9-18.2,0.4L302.6,299.8L295.1,303.9",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000064325462356399213180000010410642306788862903_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000013154879130281639750000013923949413454929086_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000064325462356399213180000010410642306788862903_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000007407649323746793520000013302982007423450005_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000039850632257845780470000000315746342163982503_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000007407649323746793520000013302982007423450005_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000039850632257845780470000000315746342163982503_)",
                                            fill: "#E0E1DB",
                                          },
                                          attrs: {
                                            x: "272.3",
                                            y: "61.8",
                                            width: "472.2",
                                            height: "579.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000000208658973607502630000009130740945953009808_",
                                      d: "M275.2,639.3v32.8c0,7.5,3.7,13.3,9.5,16.6l0.4,0.4\n\t\t\t\t\t\tl0,0c5.4,2.9,12.4,3.3,19.1,0l428.2-242.9c5.8-3.3,9.5-9.9,9.5-16.6v-54.7L275.2,639.3",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000146481485751834430210000002281183198673405586_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000000208658973607502630000009130740945953009808_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000146481485751834430210000002281183198673405586_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000127723292553983966670000004896331111685835934_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000161622950272029690920000016180553642455767707_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000127723292553983966670000004896331111685835934_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000161622950272029690920000016180553642455767707_)",
                                            fill: "#25292A",
                                          },
                                          attrs: {
                                            x: "273.1",
                                            y: "372.3",
                                            width: "471.4",
                                            height: "322.5",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000176724217792110916830000012411218717200185757_",
                                      d: "M275.2,672.5v-32.8h-0.4l-13.3-7.9v32.3\n\t\t\t\t\t\tc0,6.6,3.3,12.4,8.3,15.8c0.8,0.4,1.7,1.2,2.5,1.7l12.4,7C279.4,685.3,275.2,679.5,275.2,672.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000113354514257321068980000017775966872522471590_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000176724217792110916830000012411218717200185757_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000113354514257321068980000017775966872522471590_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000069397590890724172470000012135660164255686840_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000008134735921635050170000017165896959630384556_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000069397590890724172470000012135660164255686840_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000008134735921635050170000017165896959630384556_)",
                                            fill: "#25292A",
                                          },
                                          attrs: {
                                            x: "259.5",
                                            y: "629.8",
                                            width: "27.8",
                                            height: "61.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000011751555437010460100000003401650594532171950_",
                                      d: "M275.2,639.3l-0.8-299.7c0-14.9,7.9-28.6,20.7-35.7\n\t\t\t\t\t\tl7-4.1l-13.7-7.9l-7.5,4.1c-12.9,7.5-20.7,21.1-20.7,35.7l0.8,300.1L275.2,639.3L275.2,639.3",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000107566517287157121450000009046689755330634381_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000011751555437010460100000003401650594532171950_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000107566517287157121450000009046689755330634381_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000013163156147515224630000014622911521793668542_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000114759859010356317020000011575520478007843246_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000013163156147515224630000014622911521793668542_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000114759859010356317020000011575520478007843246_)",
                                            fill: "#25292A",
                                          },
                                          attrs: {
                                            x: "258.6",
                                            y: "289.4",
                                            width: "46",
                                            height: "352.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000072250254037756355920000008863053462069391031_",
                                      points:
                                        "302.6,299.8 302.6,299.8 295.1,303.9\n\t\t\t\t\t\t302.6,299.8 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000181792566823452212810000014524392050090418620_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000072250254037756355920000008863053462069391031_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000181792566823452212810000014524392050090418620_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000085241895523271689950000006769697924664278683_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000127034547875117195000000014720728729318734508_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000085241895523271689950000006769697924664278683_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000127034547875117195000000014720728729318734508_)",
                                            fill: "#A4A6A5",
                                          },
                                          attrs: {
                                            x: "293",
                                            y: "297.7",
                                            width: "11.6",
                                            height: "8.7",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000090263145943294789530000003409774673398204040_",
                                      d: "M642.9,655.9c6.6-2.9,15.3-4.6,24.9-4.6\n\t\t\t\t\t\tc7.9,0,15.3,1.2,21.6,3.3L667.8,670L642.9,655.9",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000083779693814879295260000004048952254687954823_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000090263145943294789530000003409774673398204040_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000083779693814879295260000004048952254687954823_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000152252740091975778130000009600098280496437152_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000073681004022187616880000017341764399320128402_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000152252740091975778130000009600098280496437152_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000073681004022187616880000017341764399320128402_)",
                                              "enable-background": "new",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000169555495580103120340000006406910015492264124_",
                                                        x: "641.3",
                                                        y: "650.5",
                                                        width: "48.9",
                                                        height: "19.9",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000119099837496729695880000003879044004328420780_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000169555495580103120340000006406910015492264124_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000119099837496729695880000003879044004328420780_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("path", {
                                                              attrs: {
                                                                id: "SVGID_00000085247867594685152320000011293831572925882809_",
                                                                d: "M642.9,655.9c6.6-2.9,15.3-4.6,24.9-4.6\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tc7.9,0,15.3,1.2,21.6,3.3L667.8,670L642.9,655.9",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000081647146965224269670000015710442599417563320_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000085247867594685152320000011293831572925882809_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000081647146965224269670000015710442599417563320_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000121978245765294367950000005031285626556972939_",
                                                                        x: "641.3",
                                                                        y: "650.5",
                                                                        width:
                                                                          "48.9",
                                                                        height:
                                                                          "19.9",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000162328881291108116120000016927483626336433285_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000121978245765294367950000005031285626556972939_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          opacity:
                                                                            "0",
                                                                          "clip-path":
                                                                            "url(#SVGID_00000162328881291108116120000016927483626336433285_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "g",
                                                                        {
                                                                          staticClass:
                                                                            "st5",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "g",
                                                                            [
                                                                              _c(
                                                                                "g",
                                                                                [
                                                                                  _c(
                                                                                    "g",
                                                                                    [
                                                                                      _c(
                                                                                        "defs",
                                                                                        [
                                                                                          _c(
                                                                                            "rect",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  id: "SVGID_00000075149805915354700490000000591755258787591296_",
                                                                                                  x: "641.3",
                                                                                                  y: "650.5",
                                                                                                  width:
                                                                                                    "48.9",
                                                                                                  height:
                                                                                                    "19.9",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "clipPath",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              id: "SVGID_00000080915006235218000150000018295703546591024819_",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "use",
                                                                                            {
                                                                                              staticStyle:
                                                                                                {
                                                                                                  overflow:
                                                                                                    "visible",
                                                                                                },
                                                                                              attrs:
                                                                                                {
                                                                                                  "xlink:href":
                                                                                                    "#SVGID_00000075149805915354700490000000591755258787591296_",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000130640082099692230610000002568108880387904405_",
                                                                        x: "641.3",
                                                                        y: "650.5",
                                                                        width:
                                                                          "48.9",
                                                                        height:
                                                                          "19.9",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000071534602776733387400000012032779534377567373_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000130640082099692230610000002568108880387904405_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "clip-path":
                                                                            "url(#SVGID_00000071534602776733387400000012032779534377567373_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c("g", [
                                                                        _c(
                                                                          "g",
                                                                          [
                                                                            _c(
                                                                              "g",
                                                                              [
                                                                                _c(
                                                                                  "defs",
                                                                                  [
                                                                                    _c(
                                                                                      "rect",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            id: "SVGID_00000084488393874095177410000011344816413996428969_",
                                                                                            x: "641.3",
                                                                                            y: "650.5",
                                                                                            width:
                                                                                              "48.9",
                                                                                            height:
                                                                                              "19.9",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "clipPath",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        id: "SVGID_00000016075322788982446500000013566433999934411648_",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "use",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            overflow:
                                                                                              "visible",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            "xlink:href":
                                                                                              "#SVGID_00000084488393874095177410000011344816413996428969_",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000151507841348534149810000002347456386574316433_",
                                      points:
                                        "689.4,654.6 689.4,670 667.8,685.3\n\t\t\t\t\t\t667.8,670 689.4,654.6 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000183966107545474150880000011294914588810350980_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000151507841348534149810000002347456386574316433_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000183966107545474150880000011294914588810350980_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000114048238280515147090000001565205172719593889_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000089575105075696463700000000493289690853077148_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000114048238280515147090000001565205172719593889_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000089575105075696463700000000493289690853077148_)",
                                              "enable-background": "new",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000106128901396160095940000013261010037834808476_",
                                                        x: "665.7",
                                                        y: "652.6",
                                                        width: "24.5",
                                                        height: "33.6",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000125574530120609753120000013905285771151074194_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000106128901396160095940000013261010037834808476_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000125574530120609753120000013905285771151074194_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000071558049572451660350000007212740341003959190_",
                                                                points:
                                                                  "689.4,654.6 689.4,670\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t667.8,685.3 667.8,670 689.4,654.6 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000096745427984441843600000003510253279505457539_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000071558049572451660350000007212740341003959190_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000096745427984441843600000003510253279505457539_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000050645535223707017180000003031051923620589196_",
                                                                        x: "665.7",
                                                                        y: "652.6",
                                                                        width:
                                                                          "24.5",
                                                                        height:
                                                                          "33.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000068669836965567593810000007050665841467006871_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000050645535223707017180000003031051923620589196_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          opacity:
                                                                            "0",
                                                                          "clip-path":
                                                                            "url(#SVGID_00000068669836965567593810000007050665841467006871_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "g",
                                                                        {
                                                                          staticClass:
                                                                            "st5",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "g",
                                                                            [
                                                                              _c(
                                                                                "g",
                                                                                [
                                                                                  _c(
                                                                                    "g",
                                                                                    [
                                                                                      _c(
                                                                                        "defs",
                                                                                        [
                                                                                          _c(
                                                                                            "rect",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  id: "SVGID_00000148661888518663596360000017181364649691377822_",
                                                                                                  x: "665.7",
                                                                                                  y: "652.6",
                                                                                                  width:
                                                                                                    "24.5",
                                                                                                  height:
                                                                                                    "33.6",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "clipPath",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              id: "SVGID_00000093864363806607935030000007207558788433286053_",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "use",
                                                                                            {
                                                                                              staticStyle:
                                                                                                {
                                                                                                  overflow:
                                                                                                    "visible",
                                                                                                },
                                                                                              attrs:
                                                                                                {
                                                                                                  "xlink:href":
                                                                                                    "#SVGID_00000148661888518663596360000017181364649691377822_",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000021836546750042515500000013795015836364419512_",
                                                                        x: "665.7",
                                                                        y: "652.6",
                                                                        width:
                                                                          "24.5",
                                                                        height:
                                                                          "33.6",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000028292981852331116660000010818137228600094630_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000021836546750042515500000013795015836364419512_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "clip-path":
                                                                            "url(#SVGID_00000028292981852331116660000010818137228600094630_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c("g", [
                                                                        _c(
                                                                          "g",
                                                                          [
                                                                            _c(
                                                                              "g",
                                                                              [
                                                                                _c(
                                                                                  "defs",
                                                                                  [
                                                                                    _c(
                                                                                      "rect",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            id: "SVGID_00000164488155459605874810000006195381798386456192_",
                                                                                            x: "665.7",
                                                                                            y: "652.6",
                                                                                            width:
                                                                                              "24.5",
                                                                                            height:
                                                                                              "33.6",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "clipPath",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        id: "SVGID_00000140016761925113696780000009247697548750624180_",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "use",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            overflow:
                                                                                              "visible",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            "xlink:href":
                                                                                              "#SVGID_00000164488155459605874810000006195381798386456192_",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000050637794487707362840000007768294925587637382_",
                                      points:
                                        "642.9,655.9 642.9,671.2 667.8,685.3\n\t\t\t\t\t\t667.8,670 642.9,655.9 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000044870615681814572120000011883729471513532040_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000050637794487707362840000007768294925587637382_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000044870615681814572120000011883729471513532040_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000047752927599135241830000000198131906291878559_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000086686650760261964440000003232477472572125861_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000047752927599135241830000000198131906291878559_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000086686650760261964440000003232477472572125861_)",
                                              "enable-background": "new",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000089538876705752815980000011695190530284792508_",
                                                        x: "641.3",
                                                        y: "655.1",
                                                        width: "26.5",
                                                        height: "31.1",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000145017711413733055910000003927539672651465617_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000089538876705752815980000011695190530284792508_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000145017711413733055910000003927539672651465617_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000030451898142793092160000001921292233550668967_",
                                                                points:
                                                                  "642.9,655.9 642.9,671.2\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t667.8,685.3 667.8,670 642.9,655.9 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000156557101609047686400000007454739505941689011_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000030451898142793092160000001921292233550668967_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000156557101609047686400000007454739505941689011_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000158005396940644104630000004987619637748954551_",
                                                                        x: "641.3",
                                                                        y: "655.1",
                                                                        width:
                                                                          "26.5",
                                                                        height:
                                                                          "31.1",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000070107141873776782730000000142919496216672161_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000158005396940644104630000004987619637748954551_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          opacity:
                                                                            "0",
                                                                          "clip-path":
                                                                            "url(#SVGID_00000070107141873776782730000000142919496216672161_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "g",
                                                                        {
                                                                          staticClass:
                                                                            "st5",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "g",
                                                                            [
                                                                              _c(
                                                                                "g",
                                                                                [
                                                                                  _c(
                                                                                    "g",
                                                                                    [
                                                                                      _c(
                                                                                        "defs",
                                                                                        [
                                                                                          _c(
                                                                                            "rect",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  id: "SVGID_00000120544646931595823300000007719315877442066867_",
                                                                                                  x: "641.3",
                                                                                                  y: "655.1",
                                                                                                  width:
                                                                                                    "26.5",
                                                                                                  height:
                                                                                                    "31.1",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "clipPath",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              id: "SVGID_00000014609280987497234240000010433217103140213148_",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "use",
                                                                                            {
                                                                                              staticStyle:
                                                                                                {
                                                                                                  overflow:
                                                                                                    "visible",
                                                                                                },
                                                                                              attrs:
                                                                                                {
                                                                                                  "xlink:href":
                                                                                                    "#SVGID_00000120544646931595823300000007719315877442066867_",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000116198527460411748800000001110304312236870078_",
                                                                        x: "641.3",
                                                                        y: "655.1",
                                                                        width:
                                                                          "26.5",
                                                                        height:
                                                                          "31.1",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000019637571233775965380000017567445191779909055_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000116198527460411748800000001110304312236870078_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "clip-path":
                                                                            "url(#SVGID_00000019637571233775965380000017567445191779909055_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c("g", [
                                                                        _c(
                                                                          "g",
                                                                          [
                                                                            _c(
                                                                              "g",
                                                                              [
                                                                                _c(
                                                                                  "defs",
                                                                                  [
                                                                                    _c(
                                                                                      "rect",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            id: "SVGID_00000145760166889176062310000004355485021064721795_",
                                                                                            x: "641.3",
                                                                                            y: "655.1",
                                                                                            width:
                                                                                              "26.5",
                                                                                            height:
                                                                                              "31.1",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "clipPath",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        id: "SVGID_00000147197468957037408440000001936409919794254234_",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "use",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            overflow:
                                                                                              "visible",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            "xlink:href":
                                                                                              "#SVGID_00000145760166889176062310000004355485021064721795_",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000018195937244288386430000001293110974265798281_",
                                      points:
                                        "705.1,676.2 705.1,681.6 667.8,685.3\n\t\t\t\t\t\t667.8,680.3 705.1,676.2 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000089570623863411260500000017342377684539835580_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000018195937244288386430000001293110974265798281_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000089570623863411260500000017342377684539835580_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000181060103244577023190000016676505034961572778_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000138564742349747522680000010874128417831225256_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000181060103244577023190000016676505034961572778_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000138564742349747522680000010874128417831225256_)",
                                            fill: "#4EBD99",
                                          },
                                          attrs: {
                                            x: "665.3",
                                            y: "674.1",
                                            width: "41.9",
                                            height: "13.3",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000011743649739737126970000007020954259783242394_",
                                      points:
                                        "587.8,404.7 572,413 557.1,407.6\n\t\t\t\t\t\t557.1,334.2 572.9,327.6 587.8,330.9 587.8,404.7 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000006693745920333185910000005122390329711035042_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000011743649739737126970000007020954259783242394_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000006693745920333185910000005122390329711035042_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000057860038049471233230000011613409845658926495_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000005239301082592111140000002627429259547668920_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000057860038049471233230000011613409845658926495_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000005239301082592111140000002627429259547668920_)",
                                            fill: "#42B994",
                                          },
                                          attrs: {
                                            x: "555",
                                            y: "325.1",
                                            width: "34.8",
                                            height: "90",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000014598119936682041840000013398824604073754806_",
                                      points:
                                        "572,413 572,339.2 557.1,334.2 557.1,407.6\n\t\t\t\t\t\t572,413 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000128467369388014944170000003971837196581719975_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000014598119936682041840000013398824604073754806_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000128467369388014944170000003971837196581719975_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000038400486860155700880000003322203916832781956_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000024710838524762273480000002334395008251819393_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000038400486860155700880000003322203916832781956_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000024710838524762273480000002334395008251819393_)",
                                            fill: "#226A57",
                                          },
                                          attrs: {
                                            x: "555",
                                            y: "331.7",
                                            width: "19.5",
                                            height: "83.3",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000160183780410982869870000000735336674421844651_",
                                      points:
                                        "587.8,330.9 572,339.2 557.1,334.2\n\t\t\t\t\t\t572.9,325.5 587.8,330.9 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000126300925942485212350000009400067404632637363_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000160183780410982869870000000735336674421844651_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000126300925942485212350000009400067404632637363_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000057142978111834255220000018327987410427981197_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000085932560118843503240000010716934941475837830_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000057142978111834255220000018327987410427981197_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000085932560118843503240000010716934941475837830_)",
                                            fill: "#165748",
                                          },
                                          attrs: {
                                            x: "555",
                                            y: "323.4",
                                            width: "34.8",
                                            height: "18.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000023964174941711477850000002877937723422149505_",
                                      points:
                                        "561.3,419.2 545.5,427.5 530.6,422.5\n\t\t\t\t\t\t530.6,325.5 546.3,318.4 561.3,322.2 561.3,419.2 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000162325769592591397480000017919550809610761651_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000023964174941711477850000002877937723422149505_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000162325769592591397480000017919550809610761651_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000158719360451731273830000010303553806146107823_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000045579933693965230340000011165345092498887605_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000158719360451731273830000010303553806146107823_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000045579933693965230340000011165345092498887605_)",
                                            fill: "#42B994",
                                          },
                                          attrs: {
                                            x: "528.5",
                                            y: "316.4",
                                            width: "34.8",
                                            height: "113.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000157310375294675678450000015320592519126001314_",
                                      points:
                                        "545.5,427.5 545.5,330.5 530.6,325.5\n\t\t\t\t\t\t530.6,422.5 545.5,427.5 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000003091814853043847780000004408210411055779978_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000157310375294675678450000015320592519126001314_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000003091814853043847780000004408210411055779978_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000157271347701516988020000013489947948446247066_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000130619684526140375830000002817825231335491751_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000157271347701516988020000013489947948446247066_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000130619684526140375830000002817825231335491751_)",
                                            fill: "#226A57",
                                          },
                                          attrs: {
                                            x: "528.5",
                                            y: "323",
                                            width: "19.5",
                                            height: "107",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000022550161589591588980000015142704079997823916_",
                                      points:
                                        "561.3,322.2 545.5,330.5 530.6,325.5\n\t\t\t\t\t\t546.3,316.8 561.3,322.2 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000173122726754385497900000012027186502866527393_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000022550161589591588980000015142704079997823916_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000173122726754385497900000012027186502866527393_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000137833432502370248240000008311508806209033877_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000069375418879951252940000010714660591343788725_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000137833432502370248240000008311508806209033877_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000069375418879951252940000010714660591343788725_)",
                                            fill: "#165748",
                                          },
                                          attrs: {
                                            x: "528.5",
                                            y: "314.7",
                                            width: "34.8",
                                            height: "18.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000114055071044678913050000006357673877091802512_",
                                      points:
                                        "534.3,433.7 519,442.4 504.1,437\n\t\t\t\t\t\t504.1,312.2 519.4,305.6 534.3,308.9 534.3,433.7 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000133495900541125548960000016941850963125559994_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000114055071044678913050000006357673877091802512_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000133495900541125548960000016941850963125559994_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000104665370904864453310000005887744106735306929_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000182509247348452951060000009178256130012822427_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000104665370904864453310000005887744106735306929_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000182509247348452951060000009178256130012822427_)",
                                            fill: "#42B994",
                                          },
                                          attrs: {
                                            x: "501.6",
                                            y: "303.1",
                                            width: "34.8",
                                            height: "141.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000133502260355580302340000000975606453569769629_",
                                      points:
                                        "519,442.4 519,317.2 504.1,312.2 504.1,437\n\t\t\t\t\t\t519,442.4 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000081621481728472996500000003190973775427814532_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000133502260355580302340000000975606453569769629_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000081621481728472996500000003190973775427814532_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000116219365663969154240000012129330242891789999_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000026140880125499578770000016422947906834840468_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000116219365663969154240000012129330242891789999_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000026140880125499578770000016422947906834840468_)",
                                            fill: "#226A57",
                                          },
                                          attrs: {
                                            x: "501.6",
                                            y: "309.7",
                                            width: "19.5",
                                            height: "134.7",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000105428496343833391400000005098858198380552578_",
                                      points:
                                        "534.3,308.9 519,317.2 504.1,312.2\n\t\t\t\t\t\t519.4,303.5 534.3,308.9 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000053511395512079795010000006854040226917162648_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000105428496343833391400000005098858198380552578_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000053511395512079795010000006854040226917162648_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000101080267444439908700000009357247895178696330_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000058554046586127580450000004102405051720728983_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000101080267444439908700000009357247895178696330_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000058554046586127580450000004102405051720728983_)",
                                            fill: "#165748",
                                          },
                                          attrs: {
                                            x: "501.6",
                                            y: "301.4",
                                            width: "34.8",
                                            height: "18.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000183218540810140438730000017557838469843837827_",
                                      points:
                                        "507.8,448.6 492.4,456.9 477.5,451.9\n\t\t\t\t\t\t477.5,352.8 492.9,346.2 507.8,349.5 507.8,448.6 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000151530861526046375710000010236963400081368995_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000183218540810140438730000017557838469843837827_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000151530861526046375710000010236963400081368995_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000039830659359363618440000017821708313156343713_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000106828968116871103760000004669037671834352295_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000039830659359363618440000017821708313156343713_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000106828968116871103760000004669037671834352295_)",
                                            fill: "#42B994",
                                          },
                                          attrs: {
                                            x: "475",
                                            y: "344.1",
                                            width: "34.8",
                                            height: "115.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000001648543843221233290000008892435505723454115_",
                                      points:
                                        "492.4,456.9 492.4,358.2 477.5,352.8\n\t\t\t\t\t\t477.5,451.9 492.4,456.9 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000100362623427844949290000001795313543669066902_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000001648543843221233290000008892435505723454115_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000100362623427844949290000001795313543669066902_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000014620792947515620370000003351738681366594949_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000173841364406952138240000016259460456986434747_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000014620792947515620370000003351738681366594949_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000173841364406952138240000016259460456986434747_)",
                                            fill: "#226A57",
                                          },
                                          attrs: {
                                            x: "475",
                                            y: "350.8",
                                            width: "19.5",
                                            height: "108.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000051359994256492248670000000599998665571772078_",
                                      points:
                                        "507.8,349.5 492.4,358.2 477.5,352.8\n\t\t\t\t\t\t492.9,344.6 507.8,349.5 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000131355278877256243820000005514376644228159401_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000051359994256492248670000000599998665571772078_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000131355278877256243820000005514376644228159401_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000151509160134212170450000002534152345757189781_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000003805911947166716900000010338157813614128820_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000151509160134212170450000002534152345757189781_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000003805911947166716900000010338157813614128820_)",
                                            fill: "#165748",
                                          },
                                          attrs: {
                                            x: "475",
                                            y: "342.1",
                                            width: "34.8",
                                            height: "18.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000123422654523654137010000002628240105924549265_",
                                      points:
                                        "481.3,463.1 465.5,471.8 450.6,466.4\n\t\t\t\t\t\t450.6,381 466.3,374.4 481.3,377.7 481.3,463.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000059311136490658975370000004218227199297148853_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000123422654523654137010000002628240105924549265_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000059311136490658975370000004218227199297148853_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000077304359454550203730000017041655263667261607_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000066483341470218031220000001793485680195304894_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000077304359454550203730000017041655263667261607_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000066483341470218031220000001793485680195304894_)",
                                            fill: "#42B994",
                                          },
                                          attrs: {
                                            x: "448.5",
                                            y: "372.3",
                                            width: "34.8",
                                            height: "101.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000117659305825180675820000014894969518163395732_",
                                      points:
                                        "465.5,471.8 465.5,386.4 450.6,381\n\t\t\t\t\t\t450.6,466.4 465.5,471.8 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000143578591490463293550000018121522771325038724_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000117659305825180675820000014894969518163395732_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000143578591490463293550000018121522771325038724_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000116234964148547568790000012125018682296342416_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000152259687440310458610000005207933920557591183_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000116234964148547568790000012125018682296342416_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000152259687440310458610000005207933920557591183_)",
                                            fill: "#226A57",
                                          },
                                          attrs: {
                                            x: "448.5",
                                            y: "379",
                                            width: "19.5",
                                            height: "94.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000004535157951221346570000017503263826107567281_",
                                      points:
                                        "481.3,377.7 465.5,386.4 450.6,381\n\t\t\t\t\t\t466.3,372.7 481.3,377.7 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000026147986725211359590000003473072039978000519_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000004535157951221346570000017503263826107567281_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000026147986725211359590000003473072039978000519_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000067948341718458859590000008070763428421737359_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000094598392268890100750000015060946225258720913_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000067948341718458859590000008070763428421737359_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000094598392268890100750000015060946225258720913_)",
                                            fill: "#165748",
                                          },
                                          attrs: {
                                            x: "448.5",
                                            y: "370.3",
                                            width: "34.8",
                                            height: "18.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000054964232650810781560000012570969022128099251_",
                                      d: "M464.7,367.8c-0.4,0-0.8,0-0.8-0.4l-23.2-35.2\n\t\t\t\t\t\tc-0.4-0.4,0-1.2,0.4-1.7s1.2-0.4,1.7,0l22,32.8l11.6-71.7c0-0.4,0.4-0.8,1.2-1.2c0.4,0,0.8,0,1.2,0.8l12.9,40.2l14.5-88.7\n\t\t\t\t\t\tc0-0.4,0.4-1.2,1.2-1.2c0.4,0,1.2,0.4,1.2,0.8l10.8,51l13.7-37.7c0-0.4,0.8-0.8,1.2-0.8c0.4,0,0.8,0.4,1.2,0.8l10.8,51.8\n\t\t\t\t\t\tl10.8-20.3c0.4-0.4,0.8-0.8,1.2-0.8s0.8,0,0.8,0.4l14.1,31.9c0.4,0.4,0,1.2-0.4,1.7s-1.2,0-1.7-0.4l-13.3-29.8L546.8,311\n\t\t\t\t\t\tc-0.4,0.4-0.8,0.8-1.2,0.8s-0.8-0.4-0.8-0.8l-11.6-51l-13.7,37.7c0,0.4-0.8,0.8-1.2,0.8c-0.4,0-0.8-0.4-0.8-0.8L507,248.8\n\t\t\t\t\t\tl-14.1,87.5c0,0.4-0.4,0.8-1.2,1.2c-0.4,0-0.8,0-1.2-0.8l-12.9-40.2l-11.6,69.6C465.9,366.9,465.5,367.4,464.7,367.8\n\t\t\t\t\t\tL464.7,367.8",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000129912464771416746060000000741167764561370293_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000054964232650810781560000012570969022128099251_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000129912464771416746060000000741167764561370293_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000075128623308690876660000008387746669991108745_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000073683948007348077670000006874875593549159603_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000075128623308690876660000008387746669991108745_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000073683948007348077670000006874875593549159603_)",
                                            fill: "#226A57",
                                          },
                                          attrs: {
                                            x: "437.7",
                                            y: "239.3",
                                            width: "137.2",
                                            height: "130.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000018236788138490519340000000208799522208468137_",
                                      d: "M465.9,367.4c-0.4,0-0.8,0-0.8-0.4l-23.2-35.2\n\t\t\t\t\t\tc-0.4-0.4,0-1.2,0.4-1.7s1.2-0.4,1.7,0l22,32.8l11.2-71.3c0-0.4,0.4-0.8,1.2-1.2c0.4,0,0.8,0,1.2,0.8l12.9,40.2l14.5-88.7\n\t\t\t\t\t\tc0-0.4,0.4-1.2,1.2-1.2c0.4,0,1.2,0.4,1.2,0.8l10.8,51l13.7-37.7c0-0.4,0.8-0.8,1.2-0.8c0.4,0,0.8,0.4,1.2,0.8l10.8,51.8\n\t\t\t\t\t\tl10.8-20.3c0.4-0.4,0.8-0.8,1.2-0.8s0.8,0,0.8,0.4l14.1,31.9c0.4,0.4,0,1.2-0.4,1.7s-1.2,0-1.7-0.4l-14.1-29.8L546.8,311\n\t\t\t\t\t\tc-0.4,0.4-0.8,0.8-1.2,0.8s-0.8-0.4-0.8-0.8l-10.8-51l-13.7,37.7c0,0.4-0.8,0.8-1.2,0.8s-0.8-0.4-1.2-0.8l-10.4-48.9\n\t\t\t\t\t\tl-14.1,87.5c0,0.4-0.4,0.8-1.2,1.2c-0.4,0-0.8,0-1.2-0.8l-12.9-40.2l-11.6,69.6C467.2,366.9,466.7,367.4,465.9,367.4\n\t\t\t\t\t\tL465.9,367.4",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000083086507608602327430000012111149299539206318_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000018236788138490519340000000208799522208468137_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000083086507608602327430000012111149299539206318_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000121257263754576915080000004400890126437719740_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000066485360502495745440000010784937341746758069_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000121257263754576915080000004400890126437719740_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000066485360502495745440000010784937341746758069_)",
                                            fill: "#FFFFFF",
                                          },
                                          attrs: {
                                            x: "439",
                                            y: "238.8",
                                            width: "137.2",
                                            height: "130.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000039098607534272365900000016693067240093446036_",
                                      d: "M509.9,233c0,2.9-1.2,5-2.9,5.4\n\t\t\t\t\t\tc-1.7,0-2.9-1.7-2.9-4.6c0-2.9,1.2-5,2.9-5.4C508.6,228.1,509.9,230.1,509.9,233",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000072970010173788448600000015707598341085618074_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000039098607534272365900000016693067240093446036_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000072970010173788448600000015707598341085618074_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000103963356631961458150000008853568970293037240_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000090276017231782437580000011961666391509351308_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000103963356631961458150000008853568970293037240_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000090276017231782437580000011961666391509351308_)",
                                            fill: "#226A57",
                                          },
                                          attrs: {
                                            x: "501.6",
                                            y: "226",
                                            width: "10.4",
                                            height: "14.5",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000011730994078833191090000001363962671825497253_",
                                      d: "M510.7,233c0,2.9-1.2,5-2.9,5.4\n\t\t\t\t\t\tc-1.7,0-2.9-1.7-2.9-4.6c0-2.9,1.2-5,2.9-5.4C509,228.1,510.7,230.1,510.7,233",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000078037387433613030220000018106327900562342549_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000011730994078833191090000001363962671825497253_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000078037387433613030220000018106327900562342549_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000047034702428735249400000009257751781713766823_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000016060143031316999230000016452967458036575391_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000047034702428735249400000009257751781713766823_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000016060143031316999230000016452967458036575391_)",
                                            fill: "#42B994",
                                          },
                                          attrs: {
                                            x: "502.4",
                                            y: "226",
                                            width: "10.4",
                                            height: "14.5",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000068668619252612877650000017851182598017337267_",
                                      d: "M479.2,284.9c0,1.7-0.8,3.3-1.7,3.3\n\t\t\t\t\t\tc-0.8,0-1.7-1.2-1.7-2.9s0.8-3.3,1.7-3.3S479.2,283.2,479.2,284.9",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000155840739435503241460000012079534628387766961_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000068668619252612877650000017851182598017337267_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000155840739435503241460000012079534628387766961_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000066512793510013649950000005632504400049333435_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000045613324973076007830000007553113929609705394_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000066512793510013649950000005632504400049333435_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000045613324973076007830000007553113929609705394_)",
                                            fill: "#226A57",
                                          },
                                          attrs: {
                                            x: "473.4",
                                            y: "279.5",
                                            width: "8.3",
                                            height: "11.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000062193050066640748520000012164924462659967121_",
                                      d: "M479.6,284.9c0,1.7-0.8,3.3-1.7,3.3\n\t\t\t\t\t\tc-0.8,0-1.7-1.2-1.7-2.9s0.8-3.3,1.7-3.3S479.6,283.2,479.6,284.9",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000134966194079508719720000002669013821844265887_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000062193050066640748520000012164924462659967121_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000134966194079508719720000002669013821844265887_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000161592031661940860430000013918686039545649580_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000104680400663638173880000016628833899133603716_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000161592031661940860430000013918686039545649580_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000104680400663638173880000016628833899133603716_)",
                                            fill: "#42B994",
                                          },
                                          attrs: {
                                            x: "473.8",
                                            y: "279.5",
                                            width: "8.3",
                                            height: "11.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000079463582183222809550000001393863952914003073_",
                                      d: "M536,248c0,1.7-0.8,3.3-1.7,3.3\n\t\t\t\t\t\tc-0.8,0-1.7-1.2-1.7-2.9c0-1.7,0.8-3.3,1.7-3.3C535.1,244.6,536,245.9,536,248",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000090275405812323024220000010208472377481649792_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000079463582183222809550000001393863952914003073_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000090275405812323024220000010208472377481649792_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000059299572743901998710000008218417017224937908_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000025422257158144973280000004124332666128414886_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000059299572743901998710000008218417017224937908_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000025422257158144973280000004124332666128414886_)",
                                            fill: "#226A57",
                                          },
                                          attrs: {
                                            x: "529.8",
                                            y: "242.6",
                                            width: "8.3",
                                            height: "11.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000075862245780988130000000009631660837644771202_",
                                      d: "M536.4,248c0,1.7-0.8,3.3-1.7,3.3s-1.7-1.2-1.7-2.9\n\t\t\t\t\t\tc0-1.7,0.8-3.3,1.7-3.3C535.6,244.6,536.4,245.9,536.4,248",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000155144947775491583770000007522917128707560593_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000075862245780988130000000009631660837644771202_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000155144947775491583770000007522917128707560593_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000002356273341483417520000018035033717495581367_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000047744227805394325810000016896385095890453675_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000002356273341483417520000018035033717495581367_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000047744227805394325810000016896385095890453675_)",
                                            fill: "#42B994",
                                          },
                                          attrs: {
                                            x: "530.2",
                                            y: "242.6",
                                            width: "8.3",
                                            height: "11.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000167362263029661946550000011356246372319374509_",
                                      d: "M474.6,526.5L474.6,526.5L742,374.4v-24l33.2-19.1\n\t\t\t\t\t\tc0.4,0,0.4-0.4,0.4-0.8s0-0.4,0-0.8s-0.4-0.4-0.8-0.4c0,0,0,0-0.4,0l0,0c0-2.5-0.4-4.6-0.4-7.5c-0.8-8.7-1.7-16.6-3.3-23.2\n\t\t\t\t\t\tc-3.7-15.3-9.5-23.2-17-23.2c-2.5,0-5.4,0.8-8.3,2.5c-1.2,0.8-2.5,1.7-3.3,2.5v-87.1l68.4-39l0.4-44.8l-0.8,257l-67.6,39v-30.7\n\t\t\t\t\t\tL474.6,526.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000043448336043961600610000000943587198759389103_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000167362263029661946550000011356246372319374509_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000043448336043961600610000000943587198759389103_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000134963390108375428440000018097999481914720144_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000028309883033440871860000010670321766783771070_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000134963390108375428440000018097999481914720144_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000028309883033440871860000010670321766783771070_)",
                                            fill: "#EBEAE6",
                                          },
                                          attrs: {
                                            x: "472.1",
                                            y: "107",
                                            width: "340.8",
                                            height: "421.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000101083475914400546600000006038544432758415030_",
                                      d: "M477.5,376.5l-2.9-1.2v-52.6l0,0V347l16.6-9.5h0.4\n\t\t\t\t\t\tc0,0,0,0,0.4,0c0,0,0.4,0,0.4-0.4h0.4c0,0,0,0,0.4,0s0.8-0.4,1.2-1.2v-0.4l10.4-5.8v18.2l-11.2-3.7l-15.8,8.7L477.5,376.5\n\t\t\t\t\t\t M604,400.5L604,400.5L604,400.5c-0.8-2.5-1.2-5-1.7-7c-0.8-4.1-2.1-7.9-4.1-10.4c-2.9-4.1-6.2-6.6-10.8-7v-44.8l-14.9-5.4\n\t\t\t\t\t\tl-11.6,6.2v-9.9l-14.9-5.4l-11.6,6.2v-10.8l8.3-5l0.8,3.3c0,0.4,0.4,0.8,0.8,0.8l0,0c0.4,0,0.4,0,0.8-0.4h0.4l0,0\n\t\t\t\t\t\tc0.4,0,0.8-0.4,1.2-0.8l4.1-7.9l9.1-5.4l9.9,22.4c0,0.4,0.4,0.4,0.8,0.4h0.4l0,0h0.4h0.4c0.4-0.4,0.8-1.2,0.4-1.7l-9.9-22.8\n\t\t\t\t\t\tl178.7-102.4v87.1c-2.9,2.5-5.8,5.4-8.7,9.9c-3.3,4.6-6.6,10.4-10.8,17.8c-4.1,8.3-7.5,13.7-9.1,17c-2.9,5.4-5.4,8.3-6.6,9.1\n\t\t\t\t\t\tc-0.4,0.4-0.8,0.4-1.2,0.4c-2.1,0-4.1-2.9-6.2-8.3c-2.9-9.5-5.4-17-7.5-22c-3.7-9.1-8.3-14.9-12.9-17.4\n\t\t\t\t\t\tc-2.1-0.8-4.1-1.7-6.2-1.7c-5,0-10.8,2.5-17.4,7.5c-10.4,7.9-18.7,17.8-25.3,30.7c-5,9.5-9.1,21.1-12.9,34\n\t\t\t\t\t\tc-1.2,4.6-2.1,9.5-3.3,15.3c-0.8,3.3-1.7,7.5-2.5,12.9c-0.8,4.1-1.7,7.5-2.1,9.5c-0.8,2.5-1.7,4.1-2.9,4.6\n\t\t\t\t\t\tC605.2,400.1,604.4,400.5,604,400.5 M474.6,526.5v-59.7l6.6-3.7v-9.9l11.2,3.7l15.8-8.7v-9.9l11.2,3.7l15.8-8.7v-9.9l5,1.7\n\t\t\t\t\t\tc-0.4,0.8-0.4,2.1-0.8,2.9c-3.7,12.9-5.4,26.1-5.8,39.4l-0.4,0.4c-0.4,0-0.4,0.4-0.4,0.8s0,0.4,0,0.8s0.4,0.4,0.8,0.4\n\t\t\t\t\t\tc0,0,0,0,0.4,0h0.4l33.2-19.1l7.5-4.1l167.9-96.2v24L474.6,526.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000150081286230673305460000000143806785017488822_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000101083475914400546600000006038544432758415030_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000150081286230673305460000000143806785017488822_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000094576447462554943110000012767151498106312621_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000129185905283502193620000013243034518766205064_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000094576447462554943110000012767151498106312621_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000129185905283502193620000013243034518766205064_)",
                                            fill: "#DCDDD7",
                                          },
                                          attrs: {
                                            x: "472.1",
                                            y: "191.2",
                                            width: "272.4",
                                            height: "337.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000075856343812085354220000015668809962964527798_",
                                      points:
                                        "474.6,558.9 474.6,526.5 742,374.4\n\t\t\t\t\t\t742,405.5 474.6,558.9 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000013157747818758363560000008520294072459126666_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000075856343812085354220000015668809962964527798_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000013157747818758363560000008520294072459126666_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000123424779111928079240000006798483665566356403_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000088111716535807187040000014418864108182239122_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000123424779111928079240000006798483665566356403_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000088111716535807187040000014418864108182239122_)",
                                            fill: "#868B89",
                                          },
                                          attrs: {
                                            x: "472.1",
                                            y: "372.3",
                                            width: "271.9",
                                            height: "188.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000050632791302827733760000015417113476444955804_",
                                      d: "M572,380.2v-40.6l15.8-8.7v44.8c-0.4,0-0.8,0-1.2,0\n\t\t\t\t\t\tC582.4,375.6,577.8,377.3,572,380.2",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000165198283130085709010000016934406041716633243_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000050632791302827733760000015417113476444955804_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000165198283130085709010000016934406041716633243_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000165928599969719165940000003519228540084703382_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000160868915715430149450000003792804300624266667_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000165928599969719165940000003519228540084703382_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000160868915715430149450000003792804300624266667_)",
                                            fill: "#95CCB9",
                                          },
                                          attrs: {
                                            x: "570",
                                            y: "328.8",
                                            width: "19.9",
                                            height: "53.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000046315537726823952760000002033987030591729579_",
                                      d: "M561.3,388.1v-52.6l11.2,3.7v40.6\n\t\t\t\t\t\tc-0.4,0-0.4,0.4-0.8,0.4C567.5,382.7,564.2,385.2,561.3,388.1",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000096777878637920855450000009571679246158782895_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000046315537726823952760000002033987030591729579_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000096777878637920855450000009571679246158782895_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000027588183375071717430000010791723411126348470_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000106116887190344733600000001737438683144581006_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000027588183375071717430000010791723411126348470_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000106116887190344733600000001737438683144581006_)",
                                            fill: "#82A79C",
                                          },
                                          attrs: {
                                            x: "558.8",
                                            y: "333.4",
                                            width: "15.8",
                                            height: "57.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000114789837187854891080000010805169387500048056_",
                                      points:
                                        "572,339.2 561.3,335.4 561.3,332.1\n\t\t\t\t\t\t572.9,325.5 587.8,330.9 572,339.2 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000075145875884532186550000002710708083593590166_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000114789837187854891080000010805169387500048056_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000075145875884532186550000002710708083593590166_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000113342096679312772670000011459933946819989146_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000074443841754712539230000008731147941774228613_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000113342096679312772670000011459933946819989146_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000074443841754712539230000008731147941774228613_)",
                                            fill: "#7FA096",
                                          },
                                          attrs: {
                                            x: "558.8",
                                            y: "323.4",
                                            width: "31.1",
                                            height: "18.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000159469555803366530950000008634388121045229725_",
                                      d: "M545.5,409.6v-79.2l15.8-8.7v9.9v3.3v52.6\n\t\t\t\t\t\tC555,393.9,549.7,400.9,545.5,409.6",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000147922676527075644670000007273636101266767771_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000159469555803366530950000008634388121045229725_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000147922676527075644670000007273636101266767771_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000021818667548806179730000014030539491445308808_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000176747207405882377430000009039152425648844966_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000021818667548806179730000014030539491445308808_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000176747207405882377430000009039152425648844966_)",
                                            fill: "#95CCB9",
                                          },
                                          attrs: {
                                            x: "543.4",
                                            y: "319.7",
                                            width: "19.9",
                                            height: "92",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000082327060548984917780000005441927779482284176_",
                                      d: "M539.3,425.4l-5-1.7v-97l11.2,3.7v79.2\n\t\t\t\t\t\tC543,414.6,541.4,419.6,539.3,425.4",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000007403122705929986640000004355608660138531496_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000082327060548984917780000005441927779482284176_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000007403122705929986640000004355608660138531496_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000082355038839442306420000015821939262865594003_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000053542114894000153190000013736681323647576723_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000082355038839442306420000015821939262865594003_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000053542114894000153190000013736681323647576723_)",
                                            fill: "#82A79C",
                                          },
                                          attrs: {
                                            x: "532.2",
                                            y: "324.2",
                                            width: "15.8",
                                            height: "103.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000029764834543398578590000017336584429038619536_",
                                      points:
                                        "545.5,330.5 534.3,326.7 534.3,323\n\t\t\t\t\t\t546.3,316.8 561.3,322.2 545.5,330.5 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000026885739648746662520000015639863456308307844_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000029764834543398578590000017336584429038619536_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000026885739648746662520000015639863456308307844_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000000908772760591140500000011611660115573648806_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000177469503644548029400000001786070596845962672_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000000908772760591140500000011611660115573648806_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000177469503644548029400000001786070596845962672_)",
                                            fill: "#7FA096",
                                          },
                                          attrs: {
                                            x: "532.2",
                                            y: "314.7",
                                            width: "31.1",
                                            height: "18.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000121258351980381427470000015728325014239904434_",
                                      points:
                                        "519,442.4 519,442.4 519,321.3 534.3,312.6\n\t\t\t\t\t\t534.3,323 534.3,326.7 534.3,433.7 519,442.4 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000082350853867387064580000011162392525935469957_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000121258351980381427470000015728325014239904434_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000082350853867387064580000011162392525935469957_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000087387821007380450810000014486374523769048242_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000001629993677818365730000013634425996993435550_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000087387821007380450810000014486374523769048242_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000001629993677818365730000013634425996993435550_)",
                                            fill: "#95CCB9",
                                          },
                                          attrs: {
                                            x: "516.5",
                                            y: "310.6",
                                            width: "19.9",
                                            height: "134.3",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000104682760614013315660000003968822991954912425_",
                                      points:
                                        "519,442.4 507.8,438.2 507.8,349.5\n\t\t\t\t\t\t504.1,348.3 504.1,330 519,321.3 519,442.4 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000117655492016393801730000015538988726658591404_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000104682760614013315660000003968822991954912425_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000117655492016393801730000015538988726658591404_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000154399063610282510080000016885090328065525393_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000169528222782691792460000017752206198152009650_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000154399063610282510080000016885090328065525393_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000169528222782691792460000017752206198152009650_)",
                                            fill: "#82A79C",
                                          },
                                          attrs: {
                                            x: "501.6",
                                            y: "319.3",
                                            width: "19.5",
                                            height: "125.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000163054936349841112740000016220476055747913881_",
                                      points:
                                        "492.4,456.9 492.4,456.9 492.4,358.2\n\t\t\t\t\t\t507.8,349.5 507.8,438.2 507.8,448.6 492.4,456.9 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000059995851554149757250000010139511341314062240_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000163054936349841112740000016220476055747913881_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000059995851554149757250000010139511341314062240_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000051370897875231106550000011165697214953523622_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000085234676818731085460000017141677725012278199_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000051370897875231106550000011165697214953523622_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000085234676818731085460000017141677725012278199_)",
                                            fill: "#95CCB9",
                                          },
                                          attrs: {
                                            x: "490",
                                            y: "347.5",
                                            width: "19.9",
                                            height: "111.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000054968331394435490880000004213335970971006879_",
                                      points:
                                        "492.4,456.9 481.3,453.2 481.3,377.7\n\t\t\t\t\t\t477.5,376.5 477.5,352.8 492.4,358.2 492.4,456.9 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000075162532953984123010000017845978584595915925_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000054968331394435490880000004213335970971006879_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000075162532953984123010000017845978584595915925_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000125598145625280668820000008115116102888048548_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000080912406200281561270000005099564223201246620_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000125598145625280668820000008115116102888048548_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000080912406200281561270000005099564223201246620_)",
                                            fill: "#82A79C",
                                          },
                                          attrs: {
                                            x: "475",
                                            y: "350.8",
                                            width: "19.5",
                                            height: "108.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000135649545728956992570000012509054800963281582_",
                                      points:
                                        "492.4,358.2 477.5,352.8 492.9,344.6\n\t\t\t\t\t\t507.8,349.5 492.4,358.2 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000043421841498839873530000009338325046645017243_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000135649545728956992570000012509054800963281582_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000043421841498839873530000009338325046645017243_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000063606166430450228930000001936185177724678078_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000013171533196272798420000007217385931521309590_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000063606166430450228930000001936185177724678078_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000013171533196272798420000007217385931521309590_)",
                                            fill: "#7FA096",
                                          },
                                          attrs: {
                                            x: "475",
                                            y: "342.1",
                                            width: "34.8",
                                            height: "18.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000112619057673170316970000015627103058098590117_",
                                      points:
                                        "474.2,466.9 474.2,381.5 481.3,377.7\n\t\t\t\t\t\t481.3,463.1 474.2,466.9 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000169557810690997753170000004222256709598401459_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000112619057673170316970000015627103058098590117_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000169557810690997753170000004222256709598401459_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000183929528712938702460000009116349934286584990_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000176734833954186404080000011528978773520280976_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000183929528712938702460000009116349934286584990_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000176734833954186404080000011528978773520280976_)",
                                            fill: "#95CCB9",
                                          },
                                          attrs: {
                                            x: "472.1",
                                            y: "375.6",
                                            width: "11.2",
                                            height: "93.3",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000039826559295659979090000017210856415107850907_",
                                      points:
                                        "474.2,381.5 474.2,375.6 477.5,376.5\n\t\t\t\t\t\t481.3,377.7 474.2,381.5 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000168831818287700683950000007805792694554886302_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000039826559295659979090000017210856415107850907_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000168831818287700683950000007805792694554886302_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000163780792984547272840000004073637321228269746_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000010301870310793464110000000308843927649819017_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000163780792984547272840000004073637321228269746_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000010301870310793464110000000308843927649819017_)",
                                            fill: "#7FA096",
                                          },
                                          attrs: {
                                            x: "472.1",
                                            y: "373.2",
                                            width: "11.2",
                                            height: "10.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000148627568886264440980000017852026400536829314_",
                                      d: "M546.3,307.2l-0.4-1.2l1.2-0.8L546.3,307.2\n\t\t\t\t\t\t M474.2,308.9v-6.2V308.9L474.2,308.9 M544.7,311.8L544.7,311.8c-0.4,0-0.8-0.4-0.8-0.8l-0.8-3.3l1.2-0.4l0.8,3.7\n\t\t\t\t\t\tc0,0.4,0.4,0.4,0.4,0.8C545.1,311.8,544.7,311.8,544.7,311.8 M571.2,320.5c-0.4,0-0.8,0-0.8-0.4l-9.9-22.4l0.8-0.4L571.2,320.5\n\t\t\t\t\t\tC571.2,320.5,571.6,320.5,571.2,320.5L571.2,320.5C571.6,320.5,571.6,320.5,571.2,320.5 M491.2,337.5L491.2,337.5L491.2,337.5\n\t\t\t\t\t\th0.8C492,337.5,491.6,337.5,491.2,337.5C491.6,337.5,491.2,337.5,491.2,337.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000034054342441768105230000016477522746967157950_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000148627568886264440980000017852026400536829314_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000034054342441768105230000016477522746967157950_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000115496562910083073120000005251330299498779580_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000155848900508259770890000003844267823029976972_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000115496562910083073120000005251330299498779580_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000155848900508259770890000003844267823029976972_)",
                                            fill: "#82A79C",
                                          },
                                          attrs: {
                                            x: "472.1",
                                            y: "294.8",
                                            width: "102",
                                            height: "45.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000031185949232445582170000012587409873243996571_",
                                      d: "M545.9,311.8C545.9,311.8,545.5,311.8,545.9,311.8\n\t\t\t\t\t\tL545.9,311.8c-0.8,0-0.8-0.4-0.8-0.8l-0.8-3.7l2.1-1.2l0.4,1.2l1.2-2.1l3.7-2.1l-4.1,7.9C546.8,311.4,546.3,311.8,545.9,311.8\n\t\t\t\t\t\t M572.5,320.5L572.5,320.5c-0.8,0-0.8-0.4-0.8-0.4l-9.9-22.8l2.1-1.2l9.9,22.8c0.4,0.4,0,1.2-0.4,1.7\n\t\t\t\t\t\tC572.9,320.5,572.5,320.5,572.5,320.5 M474.2,322.6v-13.7l0,0V322.6L474.2,322.6 M492.4,337.5L492.4,337.5\n\t\t\t\t\t\tc-0.4,0-0.8,0-0.8-0.4l2.1-1.2v0.4C493.7,337.1,493.3,337.5,492.4,337.5L492.4,337.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000151506125889714401520000013475980733444738748_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000031185949232445582170000012587409873243996571_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000151506125889714401520000013475980733444738748_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000068677978506804081500000017866920804554746290_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000117657844369169125200000012032272899753270672_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000068677978506804081500000017866920804554746290_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000117657844369169125200000012032272899753270672_)",
                                            fill: "#EBEBE7",
                                          },
                                          attrs: {
                                            x: "472.1",
                                            y: "293.6",
                                            width: "104.1",
                                            height: "46",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000150093315326383427690000009148536315843266222_",
                                      points:
                                        "810.8,109.5 474.2,302.7 464.7,299\n\t\t\t\t\t\t798.4,109.5 810.8,109.5 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000047025717421444234740000008172410691197282951_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000150093315326383427690000009148536315843266222_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000047025717421444234740000008172410691197282951_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000128479983356281769080000006914272395165972151_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000031923724778461510880000010421509502525770175_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000128479983356281769080000006914272395165972151_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000031923724778461510880000010421509502525770175_)",
                                            fill: "#999A98",
                                          },
                                          attrs: {
                                            x: "462.6",
                                            y: "107",
                                            width: "350.3",
                                            height: "197.7",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000138573438822973216170000010673195205680872839_",
                                      points:
                                        "464.7,299 465.9,553.1 474.6,558.9\n\t\t\t\t\t\t474.2,302.7 464.7,299 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000155104750753940878990000011188244722643248046_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000138573438822973216170000010673195205680872839_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000155104750753940878990000011188244722643248046_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000000193806344112426700000008707217509596367767_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000059277271637122463850000008678434777581141897_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000000193806344112426700000008707217509596367767_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000059277271637122463850000008678434777581141897_)",
                                            fill: "#999A98",
                                          },
                                          attrs: {
                                            x: "462.6",
                                            y: "296.9",
                                            width: "14.1",
                                            height: "264.1",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000155140534092308037430000002469996394695418295_",
                                      d: "M791.8,136.5c-0.8,0-1.7,0.4-2.9,0.8\n\t\t\t\t\t\tc-2.9,1.7-5,5-5.8,8.3c0,0.8-0.4,1.2-0.4,2.1c0,2.5,1.2,4.1,3.3,4.1c0.8,0,1.7-0.4,2.9-0.8c3.3-2.1,6.2-6.6,6.2-10.4\n\t\t\t\t\t\tc0-2.1-0.8-3.3-1.7-3.7C792.6,136.5,792.2,136.5,791.8,136.5 M771.4,148.9c-0.8,0-1.7,0.4-2.9,0.8c-2.9,1.7-5,5-5.8,8.3\n\t\t\t\t\t\tc0,0.8,0,1.2,0,2.1c0,2.5,1.2,4.1,3.3,4.1c0.8,0,1.7-0.4,2.9-0.8c3.3-2.1,6.2-6.6,6.2-10.4c0-2.1-0.8-3.3-1.7-3.7\n\t\t\t\t\t\tC772.3,148.9,771.9,148.9,771.4,148.9 M751.1,160.1c-0.8,0-1.7,0.4-2.9,0.8c-2.9,1.7-5,5-5.8,8.3c0,0.8,0,1.2,0,2.1\n\t\t\t\t\t\tc0,2.5,1.2,4.1,3.3,4.1c0.8,0,1.7-0.4,2.9-0.8c3.3-2.1,6.2-6.6,6.2-10.4c0-2.1-0.8-3.3-1.7-3.7\n\t\t\t\t\t\tC752.4,160.5,752,160.1,751.1,160.1 M742.4,193.2v-44.8l68.4-39.4l-0.4,44.8L742.4,193.2",
                                    },
                                  }),
                                ]),
                                _c("use", {
                                  staticStyle: {
                                    overflow: "visible",
                                    fill: "#6B59A6",
                                  },
                                  attrs: {
                                    "xlink:href":
                                      "#SVGID_00000155140534092308037430000002469996394695418295_",
                                  },
                                }),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000142157333191830713010000006771342043777884058_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000155140534092308037430000002469996394695418295_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000142157333191830713010000006771342043777884058_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000130621497719262316000000008687929454509825982_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c("use", {
                                          staticStyle: {
                                            overflow: "visible",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            "xlink:href":
                                              "#SVGID_00000130621497719262316000000008687929454509825982_",
                                          },
                                        }),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000008142798140722091530000017033555547568096390_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000130621497719262316000000008687929454509825982_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000008142798140722091530000017033555547568096390_)",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            x: "739.9",
                                            y: "107",
                                            width: "73",
                                            height: "88.3",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000075848132130983784230000009518895989681516725_",
                                      d: "M519,291.1l-2.5-12.4l9.1-5.4L519,291.1 M550.9,303.1\n\t\t\t\t\t\tl6.2-12l2.9,6.6L550.9,303.1 M545.9,305.6l-8.3-39.4L742,148.9v44.8L563.3,296.1l-4.1-9.1c0-0.4-0.4-0.4-0.8-0.4l0,0\n\t\t\t\t\t\tc-0.4,0-0.4,0-0.8,0.4h-0.4l0,0c-0.4,0-0.8,0.4-1.2,0.8L545.9,305.6 M491.6,328.8l-9.5-30.7l16.2-9.1L491.6,328.8 M493.7,335.9\n\t\t\t\t\t\tl7.9-48.9l11.6-6.6l3.7,17.4c0,0.4,0.4,0.8,0.8,0.8l0,0c0.4,0,0.4,0,0.8-0.4h0.4l0,0c0.4,0,0.8-0.4,1.2-0.8l9.9-26.9l4.6-2.5\n\t\t\t\t\t\tl8.3,39.8l-8.3,5v-3.7l-14.9-5.4l-15.8,8.7V330L493.7,335.9 M474.6,347v-24.5l3.7-22l0.8-0.4l11.6,36.9c0,0.4,0.4,0.4,0.4,0.4\n\t\t\t\t\t\tL474.6,347",
                                    },
                                  }),
                                ]),
                                _c("use", {
                                  staticStyle: {
                                    overflow: "visible",
                                    fill: "#6B59A6",
                                  },
                                  attrs: {
                                    "xlink:href":
                                      "#SVGID_00000075848132130983784230000009518895989681516725_",
                                  },
                                }),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000155828084111042749960000006595407977177333642_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000075848132130983784230000009518895989681516725_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000155828084111042749960000006595407977177333642_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000022528964346400194580000018159987162658725304_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c("use", {
                                          staticStyle: {
                                            overflow: "visible",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            "xlink:href":
                                              "#SVGID_00000022528964346400194580000018159987162658725304_",
                                          },
                                        }),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000075855077475667754020000012949324476827793076_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000022528964346400194580000018159987162658725304_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000075855077475667754020000012949324476827793076_)",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            x: "472.1",
                                            y: "146.4",
                                            width: "272.4",
                                            height: "202.7",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000087410156255762852030000014817833724087819197_",
                                      points:
                                        "519,321.3 519,317.2 534.3,308.9\n\t\t\t\t\t\t534.3,312.6 519,321.3 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000155833463667436801640000005654997322893523131_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000087410156255762852030000014817833724087819197_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000155833463667436801640000005654997322893523131_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000066487125833113251320000014507214566471203248_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000002371242808352070470000001923251312826728605_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000066487125833113251320000014507214566471203248_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000002371242808352070470000001923251312826728605_)",
                                            fill: "#548D7A",
                                          },
                                          attrs: {
                                            x: "516.5",
                                            y: "306.4",
                                            width: "19.9",
                                            height: "17",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000152242381241748307060000006223637515455609011_",
                                      points:
                                        "504.1,330 504.1,312.2 519,317.2 519,321.3\n\t\t\t\t\t\t504.1,330 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000145741102894558187980000011279562450950156166_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000152242381241748307060000006223637515455609011_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000145741102894558187980000011279562450950156166_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000003088788586309890360000014615835910715903416_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000047766464845995924950000002809789182448937650_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000003088788586309890360000014615835910715903416_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000047766464845995924950000002809789182448937650_)",
                                            fill: "#4D8271",
                                          },
                                          attrs: {
                                            x: "501.6",
                                            y: "309.7",
                                            width: "19.5",
                                            height: "22.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000050662460770479843080000015676640081698971540_",
                                      points:
                                        "519,317.2 504.1,312.2 519.4,303.5\n\t\t\t\t\t\t534.3,308.9 519,317.2 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000163048162173689481140000003911771556902673543_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000050662460770479843080000015676640081698971540_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000163048162173689481140000003911771556902673543_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000113316140560679695940000004260931964495571623_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000129199487758449653300000006347128683897959322_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000113316140560679695940000004260931964495571623_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000129199487758449653300000006347128683897959322_)",
                                            fill: "#4A7F6F",
                                          },
                                          attrs: {
                                            x: "501.6",
                                            y: "301.4",
                                            width: "34.8",
                                            height: "18.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000046336349793892252370000014016147211628031892_",
                                      d: "M519.4,293.2l-0.4-2.1l6.6-17.8l1.2-0.8L519.4,293.2\n\t\t\t\t\t\t M560.4,297.7l-2.9-6.6l0.8-1.2l3.3,7.5L560.4,297.7 M517.7,298.5c-0.4,0-0.8-0.4-0.8-0.8l-3.7-17.4l1.2-0.4l3.7,17.8\n\t\t\t\t\t\tc0,0.4,0.4,0.4,0.4,0.8C518.6,298.5,518.1,298.5,517.7,298.5C518.1,298.5,517.7,298.5,517.7,298.5 M546.3,306L546.3,306\n\t\t\t\t\t\tl9.9-19.1c0.4-0.4,0.8-0.8,1.2-0.8l0,0h0.4l-0.4,0.4l-9.9,18.2L546.3,306 M543,307.7l-8.3-39.8l1.2-0.4l8.3,39.8L543,307.7\n\t\t\t\t\t\t M474.2,308.9v-6.2l1.2-0.8L474.2,308.9 M492.4,331.3l-0.8-2.5l6.6-39.8l1.2-0.8L492.4,331.3 M490.8,337.5\n\t\t\t\t\t\tC490.4,337.5,490.4,337.1,490.8,337.5l-12-37.3l0.8-0.4L490.8,337.5L490.8,337.5L490.8,337.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000040537660143000389780000005112159796579313537_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000046336349793892252370000014016147211628031892_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000040537660143000389780000005112159796579313537_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000024710707882916994600000005113766090138418828_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000143615698692890654580000013953922545116376729_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000024710707882916994600000005113766090138418828_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000143615698692890654580000013953922545116376729_)",
                                            fill: "#4D8271",
                                          },
                                          attrs: {
                                            x: "472.1",
                                            y: "265.4",
                                            width: "91.6",
                                            height: "74.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000047772985554268769080000012250907594642902682_",
                                      d: "M519,298.5L519,298.5c-0.8,0-0.8-0.4-0.8-0.8\n\t\t\t\t\t\tl-3.7-17.8l2.1-1.2l2.9,14.5l7.5-20.7l2.9-1.7l-9.9,26.9C520.2,298.1,519.8,298.5,519,298.5L519,298.5 M547.6,305.2l9.9-18.2\n\t\t\t\t\t\tl0.4-0.4c0,0,0.4-0.4,0.8-0.4l0,0c0.4,0,0.8,0.4,0.8,0.4l4.1,9.1l-2.1,1.2l-3.7-7l-7,13.3L547.6,305.2 M543.9,307.2l-8.3-39.8\n\t\t\t\t\t\tl2.1-1.2l8.3,39.4v0.4L543.9,307.2 M474.2,322.6v-13.7l1.2-6.6l2.5-1.7L474.2,322.6 M491.6,337.1L491.6,337.1l-12-37.3l2.1-1.2\n\t\t\t\t\t\tl10.4,32.8l7-42.7l2.5-1.7l-7.9,48.9L491.6,337.1",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000043443760178525561210000002249277290236946073_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000047772985554268769080000012250907594642902682_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000043443760178525561210000002249277290236946073_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000170243062864845414970000017703536971143855013_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000053528542511090821680000005226708560919254150_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000170243062864845414970000017703536971143855013_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000053528542511090821680000005226708560919254150_)",
                                            fill: "#699687",
                                          },
                                          attrs: {
                                            x: "472.1",
                                            y: "264.1",
                                            width: "93.7",
                                            height: "75.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000013193526354598107660000008628445895324498311_",
                                      d: "M745.7,175.4c-2.1,0-3.3-1.7-3.3-4.1\n\t\t\t\t\t\tc0-0.4,0-1.2,0-2.1c0.8-3.3,2.9-6.6,5.8-8.3c0.8-0.4,2.1-0.8,2.9-0.8c0.4,0,1.2,0,1.7,0.4c1.2,0.4,1.7,2.1,1.7,3.7\n\t\t\t\t\t\tc0,3.7-2.9,8.3-6.2,10.4C747.4,175.4,746.6,175.4,745.7,175.4",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000094578955112991459980000007855919665849311126_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000013193526354598107660000008628445895324498311_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000094578955112991459980000007855919665849311126_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000148649179718381499730000000923208999906948995_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000160148688567019143240000001402796388185941688_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000148649179718381499730000000923208999906948995_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000160148688567019143240000001402796388185941688_)",
                                            fill: "#C9DAD1",
                                          },
                                          attrs: {
                                            x: "740.4",
                                            y: "158",
                                            width: "16.6",
                                            height: "19.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000133501666260956879760000008698194635100842650_",
                                      d: "M766.1,164.2c-2.1,0-3.3-1.7-3.3-4.1\n\t\t\t\t\t\tc0-0.4,0-1.2,0-2.1c0.8-3.3,2.9-6.6,5.8-8.3c0.8-0.4,2.1-0.8,2.9-0.8c0.4,0,1.2,0,1.7,0.4c1.2,0.4,1.7,2.1,1.7,3.7\n\t\t\t\t\t\tc0,3.7-2.9,8.3-6.2,10.4C767.7,163.8,766.9,164.2,766.1,164.2",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000148619759762829847970000000836169909675194507_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000133501666260956879760000008698194635100842650_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000148619759762829847970000000836169909675194507_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000077313320690751840980000009360598259538807730_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000026146331970889443480000000364050091786233758_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000077313320690751840980000009360598259538807730_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000026146331970889443480000000364050091786233758_)",
                                            fill: "#C9DAD1",
                                          },
                                          attrs: {
                                            x: "760.2",
                                            y: "146.4",
                                            width: "16.6",
                                            height: "19.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000012437191281226494900000006501195549256640903_",
                                      d: "M786,151.8c-2.1,0-3.3-1.7-3.3-4.1\n\t\t\t\t\t\tc0-0.4,0-1.2,0.4-2.1c0.8-3.3,2.9-6.6,5.8-8.3c0.8-0.4,2.1-0.8,2.9-0.8c0.4,0,1.2,0,1.7,0.4c1.2,0.4,1.7,2.1,1.7,3.7\n\t\t\t\t\t\tc0,3.7-2.9,8.3-6.2,10.4C788,151.4,786.8,151.8,786,151.8",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000071543200229051254740000009857149473987777666_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000012437191281226494900000006501195549256640903_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000071543200229051254740000009857149473987777666_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000084509065046007768580000003577362753341164706_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000165949203448966399880000016773845115836023997_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000084509065046007768580000003577362753341164706_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000165949203448966399880000016773845115836023997_)",
                                            fill: "#C9DAD1",
                                          },
                                          attrs: {
                                            x: "780.6",
                                            y: "134.4",
                                            width: "16.6",
                                            height: "19.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000126315266608797559090000008401838554562582179_",
                                      d: "M565.8,449l7.5-4.1l15.8-9.1l184.9-106.1\n\t\t\t\t\t\tc0.4,0,0.4,0,0.8,0s0.4,0.4,0.8,0.4c0,0.4,0,0.4,0,0.8s-0.4,0.4-0.4,0.8L574.1,447l-7.5,4.1l-33.2,19.1c-0.4,0-0.4,0-0.8,0\n\t\t\t\t\t\ts-0.4-0.4-0.8-0.4c0-0.4,0-0.4,0-0.8s0.4-0.4,0.4-0.8l30.3-17.4L565.8,449",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000059267427317124506230000002225941632719441337_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000126315266608797559090000008401838554562582179_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000059267427317124506230000002225941632719441337_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000043448849584670721890000007486117577935862178_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000084514892268090787100000003488946270571185576_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000043448849584670721890000007486117577935862178_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000084514892268090787100000003488946270571185576_)",
                                            fill: "#165748",
                                          },
                                          attrs: {
                                            x: "529.3",
                                            y: "327.1",
                                            width: "248.7",
                                            height: "145.5",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000065043857932102153160000007817995431338106020_",
                                      d: "M781,281.5c-0.4-0.4-0.8-0.4-1.2-0.8l0,0\n\t\t\t\t\t\tc-1.2-1.2-1.7-2.9-1.7-4.6s0.8-3.3,2.1-4.6c1.2-1.2,2.9-2.1,4.6-2.1c1.7,0,3.3,0.8,4.6,2.1c1.2,1.2,2.1,2.9,2.1,4.6\n\t\t\t\t\t\tc0,1.7-0.8,3.3-2.1,4.6c-1.2,1.2-2.9,2.1-4.6,2.1C783.1,282.4,781.8,282.4,781,281.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000116940640227669638680000011294698791379794104_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000065043857932102153160000007817995431338106020_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000116940640227669638680000011294698791379794104_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000010299721470181787920000004765727167003350927_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000029017945337917109410000002048770788001167516_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000010299721470181787920000004765727167003350927_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000029017945337917109410000002048770788001167516_)",
                                            fill: "#165748",
                                          },
                                          attrs: {
                                            x: "775.6",
                                            y: "267.5",
                                            width: "17.4",
                                            height: "17.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000154414757790364949800000018066477696207086773_",
                                      d: "M725.8,263.3c-0.4,0.8-0.8,1.2-1.2,2.1\n\t\t\t\t\t\tc-1.2,1.2-2.9,2.1-4.6,2.1c-1.7,0-3.3-0.8-4.6-2.1c-0.4-0.4-0.4-0.4-0.4-0.8c-0.4-0.4-0.8-0.8-0.8-1.7\n\t\t\t\t\t\tc-0.4-0.8-0.4-1.7-0.4-2.5c0-1.7,0.8-3.3,2.1-4.6c1.2-1.2,2.9-2.1,4.6-2.1c1.7,0,3.3,0.8,4.6,2.1c1.2,1.2,2.1,2.9,2.1,4.6\n\t\t\t\t\t\tc0,0.4,0,0.8,0,0.8C726.3,262.1,725.8,262.9,725.8,263.3",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000153684832263559116940000008123670069130320279_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000154414757790364949800000018066477696207086773_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000153684832263559116940000008123670069130320279_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000016044167693087518370000001014381735413012377_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000106135713856487361340000014393261395480711836_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000016044167693087518370000001014381735413012377_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000106135713856487361340000014393261395480711836_)",
                                            fill: "#165748",
                                          },
                                          attrs: {
                                            x: "711.3",
                                            y: "252.1",
                                            width: "17.4",
                                            height: "17.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000127036166164569196340000005424672554602708127_",
                                      d: "M506.1,419.2c0.8,1.2,1.2,2.5,1.2,3.7\n\t\t\t\t\t\tc0,1.7-0.8,3.3-2.1,4.6c-1.2,1.2-2.9,2.1-4.6,2.1s-3.3-0.8-4.6-2.1c-1.2-1.2-2.1-2.9-2.1-4.6s0.8-3.3,2.1-4.6\n\t\t\t\t\t\tc1.2-1.2,2.9-2.1,4.6-2.1s2.9,0.4,4.1,1.2l0.4,0.4C505.7,418.8,505.7,418.8,506.1,419.2",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000075875443132147315510000010674013350057652400_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000127036166164569196340000005424672554602708127_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000075875443132147315510000010674013350057652400_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000052819249653939403640000013963067160853724814_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000092439198021602879250000007003462589534821548_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000052819249653939403640000013963067160853724814_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000092439198021602879250000007003462589534821548_)",
                                            fill: "#165748",
                                          },
                                          attrs: {
                                            x: "492",
                                            y: "414.2",
                                            width: "17.4",
                                            height: "17.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000143617759745975386120000009411308897985483165_",
                                      d: "M742,347.9v-67.6c1.2-0.8,2.5-1.7,3.3-2.5\n\t\t\t\t\t\tc2.9-1.7,5.8-2.5,8.3-2.5c7.5,0,13.3,7.9,17,23.2c1.7,6.6,2.9,14.5,3.3,23.2c0.4,2.5,0.4,5,0.4,7.5h-0.4L742,347.9",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000130643023676839990260000003504480322934951857_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000143617759745975386120000009411308897985483165_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000130643023676839990260000003504480322934951857_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000052822086655627208970000009244479236431888829_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000081620770470016503930000013349514507703949501_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000052822086655627208970000009244479236431888829_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000081620770470016503930000013349514507703949501_)",
                                            fill: "#A4B6AD",
                                          },
                                          attrs: {
                                            x: "739.9",
                                            y: "273.3",
                                            width: "36.9",
                                            height: "77.1",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000121239851993277564390000000157298123600312744_",
                                      d: "M532.7,468.1c0-13.7,2.1-26.5,5.8-39.4\n\t\t\t\t\t\tc0.4-0.8,0.4-2.1,0.8-2.9l6.2,2.1l15.8-8.7v-9.9l11.2,3.7l15.8-8.7v-28.6c4.6,0.4,8.3,2.9,10.8,7c1.7,2.5,2.9,6.2,4.1,10.4\n\t\t\t\t\t\tc0.4,2.1,0.8,4.6,1.2,6.6v0.4c0,0,0,0,0.4,0s0.8-0.4,1.7-0.8c0.8-0.4,2.1-2.1,2.9-4.6c0.8-2.1,1.2-5,2.1-9.5\n\t\t\t\t\t\tc0.8-5.4,1.7-9.5,2.5-12.9c1.2-5.8,2.1-11.2,3.3-15.3c3.3-12.9,7.5-24.5,12.9-34c6.6-12.4,15.3-22.8,25.3-30.7\n\t\t\t\t\t\tc6.6-5,12.4-7.5,17.4-7.5c2.5,0,4.6,0.4,6.2,1.7c5,2.5,9.1,8.3,12.9,17.4c2.1,5,4.6,12.4,7.5,22c2.1,5.4,4.1,8.3,6.2,8.3\n\t\t\t\t\t\tc0.4,0,0.8,0,1.2-0.4c1.7-0.8,3.7-3.7,6.6-9.1c1.7-3.3,5-8.7,9.1-17c4.1-7.5,7.9-13.7,10.8-17.8c2.9-4.1,5.8-7.5,8.7-9.9v67.6\n\t\t\t\t\t\tl-153,88.3l-15.8,9.1l-7.5,4.1l-3.3,1.7L532.7,468.1",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000078765267498667009950000016116814448130351036_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000121239851993277564390000000157298123600312744_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000078765267498667009950000016116814448130351036_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000105388286411118611580000001200572427973408655_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000017486512574832707420000002261923562419842463_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000105388286411118611580000001200572427973408655_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000017486512574832707420000002261923562419842463_)",
                                            fill: "#A2B3AB",
                                          },
                                          attrs: {
                                            x: "530.6",
                                            y: "278.2",
                                            width: "213.9",
                                            height: "192.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000080904540992546603480000000888961666764643460_",
                                      d: "M572,413L572,413v-32.8c5.4-2.9,10.4-4.6,14.1-4.6\n\t\t\t\t\t\tc0.4,0,0.8,0,1.2,0v28.6L572,413",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000065763583945641865820000016790557623336431543_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000080904540992546603480000000888961666764643460_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000065763583945641865820000016790557623336431543_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000088847849337073820470000009976494675416550033_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000157296394222284296770000007093286671722937501_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000088847849337073820470000009976494675416550033_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000157296394222284296770000007093286671722937501_)",
                                            fill: "#91B1A5",
                                          },
                                          attrs: {
                                            x: "570",
                                            y: "373.6",
                                            width: "19.9",
                                            height: "41.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000128457753481888325950000018393715124358793379_",
                                      d: "M572,413l-11.2-3.7v-20.7c3.3-2.9,6.6-5.4,10.4-7.5\n\t\t\t\t\t\tc0.4,0,0.4-0.4,0.8-0.4V413",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000044149604059551291420000001321848012726859671_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000128457753481888325950000018393715124358793379_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000044149604059551291420000001321848012726859671_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000165227973896201820320000011747917961086423980_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000113347239121130311310000017975098289740414623_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000165227973896201820320000011747917961086423980_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000113347239121130311310000017975098289740414623_)",
                                            fill: "#8BA79D",
                                          },
                                          attrs: {
                                            x: "558.8",
                                            y: "378.1",
                                            width: "15.8",
                                            height: "37.3",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000075841851590635475920000014991708235554308239_",
                                      d: "M545.5,427.5L545.5,427.5v-17.8\n\t\t\t\t\t\tc4.1-8.7,9.5-15.8,15.8-21.6v31.1L545.5,427.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000083058562315588194460000009002199922236297131_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000075841851590635475920000014991708235554308239_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000083058562315588194460000009002199922236297131_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000026863407629834121970000006099538370818717354_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000043437583369715250690000014260586603738892695_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000026863407629834121970000006099538370818717354_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000043437583369715250690000014260586603738892695_)",
                                            fill: "#91B1A5",
                                          },
                                          attrs: {
                                            x: "543.4",
                                            y: "386",
                                            width: "19.9",
                                            height: "43.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000152248217778075693320000015916593595562909352_",
                                      d: "M545.5,427.5l-6.2-2.1c1.7-5.8,3.7-11.2,6.2-15.8\n\t\t\t\t\t\tV427.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000129180703278713530540000006441659227810630829_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000152248217778075693320000015916593595562909352_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000129180703278713530540000006441659227810630829_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000086680590776596392740000015913436798595832462_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000150789924440217800490000017961830118643430550_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000086680590776596392740000015913436798595832462_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000150789924440217800490000017961830118643430550_)",
                                            fill: "#8BA79D",
                                          },
                                          attrs: {
                                            x: "537.2",
                                            y: "407.6",
                                            width: "10.8",
                                            height: "22.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000153686550209863961110000000689861279801350836_",
                                      d: "M532.7,469.3c0-0.4,0-0.8,0-1.2l29.8-17l3.3-1.7\n\t\t\t\t\t\tl7.5-4.1l15.8-9.1L773.9,330h0.4c0,0.4,0,0.8,0,1.2L532.7,469.3",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000045614073290976215880000000965728717324001920_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000153686550209863961110000000689861279801350836_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000045614073290976215880000000965728717324001920_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000053526113228269889860000015180840393021834133_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000142889072940972188060000004997935002239531658_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000053526113228269889860000015180840393021834133_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000142889072940972188060000004997935002239531658_)",
                                            fill: "#6E9084",
                                          },
                                          attrs: {
                                            x: "530.6",
                                            y: "327.1",
                                            width: "246.2",
                                            height: "144.3",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000062158941718342248930000012415232248073960854_",
                                      d: "M535.6,374c-0.8,1.2-1.7,2.1-2.5,3.3\n\t\t\t\t\t\tc-6.2,8.7-13.3,19.5-21.1,31.9c-2.1,3.3-4.1,6.6-6.2,9.9c0-0.4-0.4-0.4-0.4-0.8l-0.4-0.4c2.1-3.7,4.6-7,6.6-10.8\n\t\t\t\t\t\tc7.9-12.4,14.9-23.2,21.1-31.5c0.8-1.2,1.7-2.5,2.5-3.3c2.1-2.9,4.1-5.4,6.2-7.5c7.5-9.1,14.1-14.9,19.1-17.4\n\t\t\t\t\t\tc12-5.8,22.4-8.7,31.1-8.7s16.6,2.5,23.2,7.9c6.2,5,10.8,7.5,13.7,7.5c15.3,0,27.4-4.6,36.9-14.1c6.2-6.6,12.4-17,18.2-31.1\n\t\t\t\t\t\tc2.9-7.9,5.4-13.3,6.6-17c2.5-6.2,5.4-11.2,7.9-14.9c4.6-6.6,9.5-10.8,15.8-13.3c0.4,0.4,0.4,0.8,0.8,1.7\n\t\t\t\t\t\tc-5.8,2.1-11.2,6.2-15.3,12.4c-2.5,3.7-5,8.3-7.5,14.5c-1.7,3.7-3.7,9.1-6.6,17c-5.8,14.5-12.4,25.3-18.7,31.9\n\t\t\t\t\t\tc-9.5,9.9-22.4,14.5-38.1,14.5c-3.3,0-7.9-2.5-14.5-7.9c-6.2-5-13.7-7.5-22-7.5c-8.7,0-18.7,2.9-30.7,8.7\n\t\t\t\t\t\tc-5,2.5-11.6,8.3-19.1,17.8C539.7,368.6,538,371.1,535.6,374",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000058569928478262470100000013437015903196046220_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000062158941718342248930000012415232248073960854_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000058569928478262470100000013437015903196046220_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000142869858998323167340000002289886372411842748_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000181802860784771799680000013793576931284312202_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000142869858998323167340000002289886372411842748_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000181802860784771799680000013793576931284312202_)",
                                            fill: "#165748",
                                          },
                                          attrs: {
                                            x: "502.8",
                                            y: "260.8",
                                            width: "214.3",
                                            height: "160.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000018223035386343158680000017945939196584631999_",
                                      d: "M781,281.5c-1.2,0.8-2.9,2.1-5,3.3\n\t\t\t\t\t\tc-4.6,2.9-7.9,4.1-9.1,4.1c-4.1,0-7.9-1.2-11.6-4.1l0,0c-2.1-1.7-5.4-4.6-9.5-8.7s-7.5-7-9.9-8.7c-3.3-2.1-6.6-3.3-9.9-3.7\n\t\t\t\t\t\tc0.4-0.4,0.4-1.2,0.4-1.7c3.3,0.4,7,1.7,10.4,4.1c2.5,1.7,5.8,4.6,9.9,9.1c4.1,4.1,7.5,7,9.5,8.7c3.7,2.5,7,3.7,10.8,3.7\n\t\t\t\t\t\tc1.2,0,3.7-1.2,8.3-3.7c1.7-1.2,3.3-2.1,4.6-2.9l0,0C780.1,281.1,780.6,281.5,781,281.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000034080709019720523020000002053285559094432391_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000018223035386343158680000017945939196584631999_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000034080709019720523020000002053285559094432391_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000129889783351995216380000009569124017319550084_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000075155612000119250440000003759963659731861931_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000129889783351995216380000009569124017319550084_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000075155612000119250440000003759963659731861931_)",
                                            fill: "#165748",
                                          },
                                          attrs: {
                                            x: "723.4",
                                            y: "259.2",
                                            width: "59.7",
                                            height: "31.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000078751838519570644830000004335178560829043606_",
                                      points:
                                        "202.7,580 202.7,430 261.1,396 261.5,546.4\n\t\t\t\t\t\t202.7,580 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000023248483083644392140000000216901637664127414_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000078751838519570644830000004335178560829043606_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000023248483083644392140000000216901637664127414_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000183953923018180601920000009644275808833402511_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000011709477963658041510000004107939466560229294_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000183953923018180601920000009644275808833402511_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000011709477963658041510000004107939466560229294_)",
                                            fill: "#EBEAE6",
                                          },
                                          attrs: {
                                            x: "200.6",
                                            y: "393.9",
                                            width: "63",
                                            height: "188.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000152233688097616444220000003494441672564426670_",
                                      d: "M275.2,538.6v-63.4c3.7,15.3,13.7,24,27.8,24\n\t\t\t\t\t\tc7,0,15.3-2.5,24-7c29-16.6,52.6-56.8,52.6-90c0-16.6-5.8-28.2-15.8-33.6c-3.7-2.1-8.3-3.3-13.3-3.3c-7,0-15.3,2.5-24,7\n\t\t\t\t\t\tc-24.5,14.1-45.2,44.4-51,73.4c0,0.8-0.4,1.7-0.4,2.9v-60.5l164.2-94.9v-29l0,0l-1.2,180.7L275.2,538.6",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000080173437192337030460000005049549053558399647_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000152233688097616444220000003494441672564426670_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000080173437192337030460000005049549053558399647_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000130632398409007176760000017717754075338061207_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000116194037149653626440000005956103501988933033_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000130632398409007176760000017717754075338061207_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000116194037149653626440000005956103501988933033_)",
                                            fill: "#DCDDD7",
                                          },
                                          attrs: {
                                            x: "272.3",
                                            y: "262.1",
                                            width: "168.7",
                                            height: "278.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000004506568501562660810000015921081231659248004_",
                                      d: "M261.5,546.4l-0.4-150.1l13.7-7.9V449\n\t\t\t\t\t\tc-0.8,4.6-1.2,9.1-1.2,13.7c0,4.6,0.4,8.7,1.2,12.9V539L261.5,546.4",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000070837380721076069170000015589821876447469454_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000004506568501562660810000015921081231659248004_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000070837380721076069170000015589821876447469454_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000119824184631712505700000007268010497446246806_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000090257577607202176370000010906656349583869873_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000119824184631712505700000007268010497446246806_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000090257577607202176370000010906656349583869873_)",
                                            fill: "#868B89",
                                          },
                                          attrs: {
                                            x: "258.6",
                                            y: "386",
                                            width: "18.7",
                                            height: "162.5",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000039830377626654831350000017476898872300892063_",
                                      d: "M288.9,442L288.9,442c-0.8,4.1-1.2,8.3-1.2,12\n\t\t\t\t\t\tc0,17,8.7,26.9,21.1,26.9c5.4,0,11.2-1.7,17.4-5.4c21.1-12,38.6-41.5,38.6-65.5c0-12-4.6-20.7-11.6-24.5l-12.4,21.1\n\t\t\t\t\t\tc3.7,2.1,6.2,6.6,6.2,13.3c0,12.9-9.5,29-20.7,35.7c-3.3,2.1-6.6,2.9-9.5,2.9c-6.6,0-11.6-5.4-11.6-14.5c0-2.1,0.4-4.1,0.8-6.6\n\t\t\t\t\t\tc2.5-11.6,10.4-23.6,20.3-29c3.3-2.1,6.6-2.9,9.5-2.9c2.1,0,3.7,0.4,5.4,1.2l12.4-21.1c-2.9-1.7-6.2-2.5-9.9-2.5\n\t\t\t\t\t\tc-5.4,0-11.2,1.7-17.4,5.4C308.4,398.9,293.5,420.8,288.9,442 M303.8,495.5c-16.2,0-27.4-12.9-27.4-34.4c0-5,0.4-10.4,1.7-15.8\n\t\t\t\t\t\tc5.8-27.4,25.3-56,48.1-69.2c8.3-4.6,15.8-6.6,22.4-6.6c4.6,0,9.1,1.2,12.4,2.9c9.1,5,14.9,15.8,14.9,31.5\n\t\t\t\t\t\tc0,31.1-22.4,69.2-49.7,85C318.3,493,310.5,495.5,303.8,495.5",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000181770588610065615230000012919818479126729407_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000039830377626654831350000017476898872300892063_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000181770588610065615230000012919818479126729407_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000079464937682900049310000006613278373816854718_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000165931721659904429880000004974385046528028855_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000079464937682900049310000006613278373816854718_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000165931721659904429880000004974385046528028855_)",
                                            fill: "#DCDDD7",
                                          },
                                          attrs: {
                                            x: "274.4",
                                            y: "366.9",
                                            width: "104.1",
                                            height: "130.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000139272065114772004700000017379729374850638504_",
                                      points:
                                        "439,264.1 202.7,400.1 196,397.2\n\t\t\t\t\t\t430.3,264.1 439,264.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000157999046921917741740000010341375294710509756_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000139272065114772004700000017379729374850638504_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000157999046921917741740000010341375294710509756_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000176731197348348204850000007733261061043532963_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000019670057550311336570000012823253744091806620_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000176731197348348204850000007733261061043532963_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000019670057550311336570000012823253744091806620_)",
                                            fill: "#999C9A",
                                          },
                                          attrs: {
                                            x: "193.6",
                                            y: "262.1",
                                            width: "247.5",
                                            height: "140.1",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000080892730069886980840000013780538294884530605_",
                                      points:
                                        "196,397.2 196.5,575.9 202.7,580\n\t\t\t\t\t\t202.7,400.1 196,397.2 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000148657592340822702360000002469675089243693751_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000080892730069886980840000013780538294884530605_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000148657592340822702360000002469675089243693751_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000001658972685106213950000013627451510574418106_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000096053320278998922090000013127969834210304655_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000001658972685106213950000013627451510574418106_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000096053320278998922090000013127969834210304655_)",
                                            fill: "#999C9A",
                                          },
                                          attrs: {
                                            x: "193.6",
                                            y: "395.1",
                                            width: "11.2",
                                            height: "187",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000151510734856704983110000005105209018372940438_",
                                      d: "M349,369c-6.6,0-14.5,2.1-22.4,6.6\n\t\t\t\t\t\tc-23.2,13.3-42.3,41.9-48.1,69.2c-1.2,5.4-1.7,10.4-1.7,15.8c0,22,11.2,34.4,27.4,34.4c6.6,0,14.5-2.1,22.4-6.6\n\t\t\t\t\t\tc27.4-15.8,49.7-53.9,49.7-85c0-15.8-5.8-26.5-14.9-31.5C357.7,369.8,353.6,369,349,369 M302.6,499.2c-13.7,0-24-8.7-27.8-24\n\t\t\t\t\t\tv-26.5c0-0.8,0.4-1.7,0.4-2.9c6.2-29,26.5-59.3,51-73.4c8.7-5,16.6-7,24-7c5,0,9.5,1.2,13.3,3.3c9.5,5.4,15.8,17,15.8,33.6\n\t\t\t\t\t\tc0,32.8-23.6,73.4-52.6,90C317.9,496.7,309.6,499.2,302.6,499.2",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000088819991615423249270000005344523677570288552_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000151510734856704983110000005105209018372940438_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000088819991615423249270000005344523677570288552_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000165194810921809814220000011884895784449364413_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000161612649104333714080000017559151301488360585_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000165194810921809814220000011884895784449364413_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000161612649104333714080000017559151301488360585_)",
                                            fill: "#98CAB7",
                                          },
                                          attrs: {
                                            x: "272.7",
                                            y: "363.2",
                                            width: "109",
                                            height: "138",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000160157666996269310190000005261554650852239011_",
                                      d: "M274.8,475.1c-0.8-3.7-1.2-7.9-1.2-12.9\n\t\t\t\t\t\tc0-4.6,0.4-9.1,1.2-13.7V475.1",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000144306938028332381130000006586209918458602889_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000160157666996269310190000005261554650852239011_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000144306938028332381130000006586209918458602889_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000126283075825223585930000014287632675304378274_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000183216136283164639960000005499484504958448293_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000126283075825223585930000014287632675304378274_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000183216136283164639960000005499484504958448293_)",
                                            fill: "#6E9A8A",
                                          },
                                          attrs: {
                                            x: "271.5",
                                            y: "446.5",
                                            width: "5.8",
                                            height: "31.1",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000179618715946837067170000000852630455832997281_",
                                      d: "M326.2,408.4v-19.9c6.2-3.7,12-5.4,17.4-5.4\n\t\t\t\t\t\tc3.7,0,7,0.8,9.9,2.5l-12.4,21.1c-1.7-0.8-3.3-1.2-5.4-1.2C332.8,405.5,329.9,406.7,326.2,408.4",
                                    },
                                  }),
                                ]),
                                _c("use", {
                                  staticStyle: {
                                    overflow: "visible",
                                    fill: "#6B59A6",
                                  },
                                  attrs: {
                                    "xlink:href":
                                      "#SVGID_00000179618715946837067170000000852630455832997281_",
                                  },
                                }),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000121243733250172885660000017025730517575424396_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000179618715946837067170000000852630455832997281_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000121243733250172885660000017025730517575424396_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000008858578523465233160000014185107790800210848_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c("use", {
                                          staticStyle: {
                                            overflow: "visible",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            "xlink:href":
                                              "#SVGID_00000008858578523465233160000014185107790800210848_",
                                          },
                                        }),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000067953372695956066010000005479071893422657975_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000008858578523465233160000014185107790800210848_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000067953372695956066010000005479071893422657975_)",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            x: "324.1",
                                            y: "381",
                                            width: "31.5",
                                            height: "29.8",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000008139724741277254160000017645976875228902534_",
                                      d: "M308.8,480.9c-12.4,0-21.1-9.9-21.1-26.9\n\t\t\t\t\t\tc0-3.7,0.4-7.9,1.2-12l17-4.6c-0.4,2.1-0.8,4.6-0.8,6.6c0,9.1,4.6,14.5,11.6,14.5c2.9,0,6.2-0.8,9.5-2.9\n\t\t\t\t\t\tc11.6-6.6,20.7-22.4,20.7-35.7c0-6.6-2.5-11.2-6.2-13.3l12.4-21.1c7,3.7,11.6,12.4,11.6,24.5c0,24-17.4,53.5-38.6,65.5\n\t\t\t\t\t\tC320,479.3,314.2,480.9,308.8,480.9",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000150073739186204776040000011678769953974644399_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000008139724741277254160000017645976875228902534_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000150073739186204776040000011678769953974644399_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000122719083088787834560000009917469461162446768_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000047745939844982837720000000036803106501098157_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000122719083088787834560000009917469461162446768_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000047745939844982837720000000036803106501098157_)",
                                            fill: "#699085",
                                          },
                                          attrs: {
                                            x: "285.6",
                                            y: "383.5",
                                            width: "81.7",
                                            height: "99.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000164507818968114182050000015538871101366274987_",
                                      d: "M288.9,442c4.6-21.1,19.5-43.5,37.3-53.5v19.9\n\t\t\t\t\t\tc-9.5,5.4-17.8,17.4-20.3,29L288.9,442",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000035528412876885815810000003130899136064700593_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000164507818968114182050000015538871101366274987_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000035528412876885815810000003130899136064700593_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000096060818505712430110000006561964282472206481_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000061434768375707878380000010010657784764843956_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000096060818505712430110000006561964282472206481_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000061434768375707878380000010010657784764843956_)",
                                            fill: "#98CAB7",
                                          },
                                          attrs: {
                                            x: "286.8",
                                            y: "386.4",
                                            width: "41.9",
                                            height: "58",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000031914495318211743300000009654092997983077778_",
                                      points:
                                        "439,264.1 438.6,264.1 439,264.1 439,264.1\n\t\t\t\t\t\t\t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000180350787409687727010000014392799696175154308_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000031914495318211743300000009654092997983077778_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000180350787409687727010000014392799696175154308_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000132090374097539792030000006116451711611282355_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000003068358880231526390000004514213950274736285_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000132090374097539792030000006116451711611282355_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000003068358880231526390000004514213950274736285_)",
                                            fill: "#679384",
                                          },
                                          attrs: {
                                            x: "436.5",
                                            y: "261.6",
                                            width: "4.6",
                                            height: "4.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000029023042326868223320000012817556840232133016_",
                                      points:
                                        "202.7,430 202.7,400.1 260.7,366.5\n\t\t\t\t\t\t261.1,396 202.7,430 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("use", {
                                  staticStyle: {
                                    overflow: "visible",
                                    fill: "#6B59A6",
                                  },
                                  attrs: {
                                    "xlink:href":
                                      "#SVGID_00000029023042326868223320000012817556840232133016_",
                                  },
                                }),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000076592184312367429150000014751859946229329283_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000029023042326868223320000012817556840232133016_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000076592184312367429150000014751859946229329283_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000116199265573110171080000014711185200092554371_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c("use", {
                                          staticStyle: {
                                            overflow: "visible",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            "xlink:href":
                                              "#SVGID_00000116199265573110171080000014711185200092554371_",
                                          },
                                        }),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000069388639243306391610000005853215057778253709_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000116199265573110171080000014711185200092554371_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000069388639243306391610000005853215057778253709_)",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            x: "200.6",
                                            y: "364",
                                            width: "62.6",
                                            height: "68",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000093867290137893052960000006394034727944617879_",
                                      d: "M422.4,286.5c-0.4,0-1.2,0-1.7,0.4\n\t\t\t\t\t\tc-1.7,0.8-3.3,2.9-3.7,5c0,0.4,0,0.8,0,1.2c0,1.7,0.8,2.5,2.1,2.5c0.4,0,1.2,0,1.7-0.4c2.1-1.2,3.7-4.1,3.7-6.2\n\t\t\t\t\t\tc0-1.2-0.4-2.1-1.2-2.5C423.2,286.5,422.8,286.5,422.4,286.5 M410.4,294c-0.4,0-1.2,0-1.7,0.4c-1.7,0.8-3.3,2.9-3.7,5\n\t\t\t\t\t\tc0,0.4,0,0.8,0,1.2c0,1.7,0.8,2.5,2.1,2.5c0.4,0,1.2,0,1.7-0.4c2.1-1.2,3.7-4.1,3.7-6.2c0-1.2-0.4-2.1-1.2-2.5\n\t\t\t\t\t\tC410.8,294,410.8,294,410.4,294 M397.9,300.6c-0.4,0-1.2,0-1.7,0.4c-1.7,0.8-3.3,2.9-3.7,5c0,0.4,0,0.8,0,1.2\n\t\t\t\t\t\tc0,1.7,0.8,2.5,2.1,2.5c0.4,0,1.2,0,1.7-0.4c2.1-1.2,3.7-4.1,3.7-6.2c0-1.2-0.4-2.1-1.2-2.5C398.8,301,398.3,300.6,397.9,300.6\n\t\t\t\t\t\t M274.8,388.1v-29.4L439,264.1v29L274.8,388.1",
                                    },
                                  }),
                                ]),
                                _c("use", {
                                  staticStyle: {
                                    overflow: "visible",
                                    fill: "#6B59A6",
                                  },
                                  attrs: {
                                    "xlink:href":
                                      "#SVGID_00000093867290137893052960000006394034727944617879_",
                                  },
                                }),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000106131068923640604390000010066173164507729057_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000093867290137893052960000006394034727944617879_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000106131068923640604390000010066173164507729057_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000126293427681734372270000008476206811927398316_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c("use", {
                                          staticStyle: {
                                            overflow: "visible",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            "xlink:href":
                                              "#SVGID_00000126293427681734372270000008476206811927398316_",
                                          },
                                        }),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000083076704797862738820000015315314717241399703_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000126293427681734372270000008476206811927398316_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000083076704797862738820000015315314717241399703_)",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            x: "272.3",
                                            y: "262.1",
                                            width: "168.7",
                                            height: "128.5",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000168117172633423768290000002064462403724051903_",
                                      points:
                                        "261.1,396 260.7,366.5 274.8,358.7\n\t\t\t\t\t\t274.8,388.1 261.1,396 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("use", {
                                  staticStyle: {
                                    overflow: "visible",
                                    fill: "#6B59A6",
                                  },
                                  attrs: {
                                    "xlink:href":
                                      "#SVGID_00000168117172633423768290000002064462403724051903_",
                                  },
                                }),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000063622882353304542240000004891461213570232207_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000168117172633423768290000002064462403724051903_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000063622882353304542240000004891461213570232207_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000136373876572204971780000013423186926672964005_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c("use", {
                                          staticStyle: {
                                            overflow: "visible",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            "xlink:href":
                                              "#SVGID_00000136373876572204971780000013423186926672964005_",
                                          },
                                        }),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000172439532012124161330000010594496373781665948_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000136373876572204971780000013423186926672964005_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000172439532012124161330000010594496373781665948_)",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            x: "258.6",
                                            y: "356.2",
                                            width: "18.2",
                                            height: "41.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000142157872381145514220000015168420635927858100_",
                                      points:
                                        "202.7,400.1 438.6,264.1 439,264.1\n\t\t\t\t\t\t439,264.1 274.8,358.7 202.7,400.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("use", {
                                  staticStyle: {
                                    overflow: "visible",
                                    fill: "#6B59A6",
                                  },
                                  attrs: {
                                    "xlink:href":
                                      "#SVGID_00000142157872381145514220000015168420635927858100_",
                                  },
                                }),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000164479181717679499140000015646621966350878894_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000142157872381145514220000015168420635927858100_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000164479181717679499140000015646621966350878894_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000065764707226197292850000006961815403550630305_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c("use", {
                                          staticStyle: {
                                            overflow: "visible",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            "xlink:href":
                                              "#SVGID_00000065764707226197292850000006961815403550630305_",
                                          },
                                        }),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000093866979543991608360000013818157505841092244_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000065764707226197292850000006961815403550630305_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000093866979543991608360000013818157505841092244_)",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            x: "200.6",
                                            y: "262.1",
                                            width: "240.4",
                                            height: "140.1",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000049934575317258193970000014628137848536939947_",
                                      points:
                                        "202.7,430 202.7,400.1 202.7,430 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000119110019735887522050000011039107021343714732_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000049934575317258193970000014628137848536939947_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000119110019735887522050000011039107021343714732_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000017505916698987425490000004946460766483044492_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000018959472083500824510000002809921651561275022_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000017505916698987425490000004946460766483044492_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000018959472083500824510000002809921651561275022_)",
                                            fill: "#547E6F",
                                          },
                                          attrs: {
                                            x: "200.6",
                                            y: "397.6",
                                            width: "4.6",
                                            height: "34.4",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000005971841401159973750000015108946679503146926_",
                                      d: "M394.6,310.1c-1.2,0-2.1-0.8-2.1-2.5\n\t\t\t\t\t\tc0-0.4,0-0.8,0-1.2c0.4-2.1,1.7-4.1,3.7-5c0.4-0.4,1.2-0.4,1.7-0.4s0.8,0,0.8,0.4c0.8,0.4,1.2,1.2,1.2,2.5c0,2.5-1.7,5-3.7,6.2\n\t\t\t\t\t\tC395.9,310.1,395,310.1,394.6,310.1",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000135679378266348399230000017502304064064964541_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000005971841401159973750000015108946679503146926_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000135679378266348399230000017502304064064964541_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000170244223932169619650000000276114478356695184_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000117665761999473991480000001872136630261518257_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000170244223932169619650000000276114478356695184_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000117665761999473991480000001872136630261518257_)",
                                            fill: "#C7D9D0",
                                          },
                                          attrs: {
                                            x: "390.5",
                                            y: "298.5",
                                            width: "12",
                                            height: "13.7",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000108297702033995022750000008979257188965378691_",
                                      d: "M407,303.1c-1.2,0-2.1-0.8-2.1-2.5c0-0.4,0-0.8,0-1.2\n\t\t\t\t\t\tc0.4-2.1,1.7-4.1,3.7-5c0.4-0.4,1.2-0.4,1.7-0.4c0.4,0,0.8,0,0.8,0.4c0.8,0.4,1.2,1.2,1.2,2.5c0,2.5-1.7,5-3.7,6.2\n\t\t\t\t\t\tC407.9,303.1,407.5,303.1,407,303.1",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000021798303509108601130000003387066030808592787_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000108297702033995022750000008979257188965378691_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000021798303509108601130000003387066030808592787_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000149355167033619477320000017218231262990229929_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000032620727272923868780000015275277124551437712_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000149355167033619477320000017218231262990229929_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000032620727272923868780000015275277124551437712_)",
                                            fill: "#C7D9D0",
                                          },
                                          attrs: {
                                            x: "402.9",
                                            y: "291.5",
                                            width: "12",
                                            height: "13.7",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000026882075436892174230000000359044974464036025_",
                                      d: "M419.1,295.6c-1.2,0-2.1-0.8-2.1-2.5\n\t\t\t\t\t\tc0-0.4,0-0.8,0-1.2c0.4-2.1,1.7-4.1,3.7-5c0.4-0.4,1.2-0.4,1.7-0.4s0.8,0,0.8,0.4c0.8,0.4,1.2,1.2,1.2,2.5c0,2.5-1.7,5-3.7,6.2\n\t\t\t\t\t\tC420.3,295.6,419.9,295.6,419.1,295.6",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000044141259766939925420000001389350310272942470_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000026882075436892174230000000359044974464036025_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000044141259766939925420000001389350310272942470_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000004542853745659110360000017470500499818801061_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000119101550351970665770000012877829066238438548_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000004542853745659110360000017470500499818801061_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000119101550351970665770000012877829066238438548_)",
                                            fill: "#C7D9D0",
                                          },
                                          attrs: {
                                            x: "414.9",
                                            y: "284",
                                            width: "12",
                                            height: "13.7",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("polyline", {
                                  staticClass: "st384",
                                  attrs: {
                                    id: "SVGID_00000142176159544854457620000015998730332086088609_",
                                    points:
                                      "924,456.1 744.5,484.7\n\t\t\t\t\t778.5,511.6 924,456.1 \t\t\t\t",
                                  },
                                }),
                              ]),
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000034082096434183204070000017398280735925921679_",
                                      points:
                                        "924,456.1 744.5,484.7 778.5,511.6\n\t\t\t\t\t\t924,456.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000032624531452150024020000010763164677660471685_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000034082096434183204070000017398280735925921679_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000032624531452150024020000010763164677660471685_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("rect", {
                                          staticClass: "st384",
                                          attrs: {
                                            id: "SVGID_00000008125393495697715560000012279838439139711626_",
                                            x: "-192",
                                            y: "-84.9",
                                            width: "1504",
                                            height: "1002.4",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000118363905146170129080000011887626745406999940_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000172428099567573890530000011337267432212063123_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000118363905146170129080000011887626745406999940_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000172428099567573890530000011337267432212063123_)",
                                              "enable-background": "new",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("g", [
                                                  _c("rect", {
                                                    staticClass: "st384",
                                                    attrs: {
                                                      id: "SVGID_00000142163830900530317530000000237817051279786882_",
                                                      x: "743.7",
                                                      y: "454.4",
                                                      width: "180.3",
                                                      height: "58",
                                                    },
                                                  }),
                                                ]),
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000149382421183521546060000007950830824672042681_",
                                                        x: "743.7",
                                                        y: "454.4",
                                                        width: "180.3",
                                                        height: "58",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000009555282761498011700000013705771873865004705_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000149382421183521546060000007950830824672042681_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000009555282761498011700000013705771873865004705_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("polyline", {
                                                            staticClass:
                                                              "st384",
                                                            attrs: {
                                                              id: "SVGID_00000129181412510765456210000012678195285080284860_",
                                                              points:
                                                                "924,456.1\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t744.5,484.7 778.5,511.6 924,456.1 \t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                            },
                                                          }),
                                                        ]),
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000171711184799810646850000003167318850391483552_",
                                                                points:
                                                                  "924,456.1 744.5,484.7\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t778.5,511.6 924,456.1 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000121967599211434147270000008727069636991809415_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000171711184799810646850000003167318850391483552_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000121967599211434147270000008727069636991809415_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("rect", {
                                                                    staticClass:
                                                                      "st384",
                                                                    attrs: {
                                                                      id: "SVGID_00000017510640417144942500000011424373037606578329_",
                                                                      x: "743.7",
                                                                      y: "454.4",
                                                                      width:
                                                                        "180.3",
                                                                      height:
                                                                        "58",
                                                                    },
                                                                  }),
                                                                ]),
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000057831927644446107850000014882814685112810890_",
                                                                        x: "743.7",
                                                                        y: "454.4",
                                                                        width:
                                                                          "180.3",
                                                                        height:
                                                                          "58",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000150103284923011827760000000611921648703036842_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000057831927644446107850000014882814685112810890_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          opacity:
                                                                            "0",
                                                                          "clip-path":
                                                                            "url(#SVGID_00000150103284923011827760000000611921648703036842_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "g",
                                                                        {
                                                                          staticClass:
                                                                            "st5",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "g",
                                                                            [
                                                                              _c(
                                                                                "g",
                                                                                [
                                                                                  _c(
                                                                                    "g",
                                                                                    [
                                                                                      _c(
                                                                                        "rect",
                                                                                        {
                                                                                          staticClass:
                                                                                            "st384",
                                                                                          attrs:
                                                                                            {
                                                                                              id: "SVGID_00000160164306497874667150000013493538564937950877_",
                                                                                              x: "743.7",
                                                                                              y: "454.4",
                                                                                              width:
                                                                                                "180.3",
                                                                                              height:
                                                                                                "58",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "g",
                                                                                    [
                                                                                      _c(
                                                                                        "defs",
                                                                                        [
                                                                                          _c(
                                                                                            "rect",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  id: "SVGID_00000132048914454535645970000003114974601177169564_",
                                                                                                  x: "743.7",
                                                                                                  y: "454.4",
                                                                                                  width:
                                                                                                    "180.3",
                                                                                                  height:
                                                                                                    "58",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "clipPath",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              id: "SVGID_00000170254971041810284010000014395445545563531455_",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "use",
                                                                                            {
                                                                                              staticStyle:
                                                                                                {
                                                                                                  overflow:
                                                                                                    "visible",
                                                                                                },
                                                                                              attrs:
                                                                                                {
                                                                                                  "xlink:href":
                                                                                                    "#SVGID_00000132048914454535645970000003114974601177169564_",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("rect", {
                                                                    staticClass:
                                                                      "st384",
                                                                    attrs: {
                                                                      id: "SVGID_00000045589096344999788750000017181908699698993052_",
                                                                      x: "743.7",
                                                                      y: "454.4",
                                                                      width:
                                                                        "180.3",
                                                                      height:
                                                                        "58",
                                                                    },
                                                                  }),
                                                                ]),
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000057832724217213307120000004694791769932812457_",
                                                                        x: "743.7",
                                                                        y: "454.4",
                                                                        width:
                                                                          "180.3",
                                                                        height:
                                                                          "58",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000113313384664168718040000011803766505998666158_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000057832724217213307120000004694791769932812457_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "clip-path":
                                                                            "url(#SVGID_00000113313384664168718040000011803766505998666158_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c("g", [
                                                                        _c(
                                                                          "g",
                                                                          [
                                                                            _c(
                                                                              "g",
                                                                              [
                                                                                _c(
                                                                                  "rect",
                                                                                  {
                                                                                    staticClass:
                                                                                      "st384",
                                                                                    attrs:
                                                                                      {
                                                                                        id: "SVGID_00000114766312178093344440000011652322252873859757_",
                                                                                        x: "743.7",
                                                                                        y: "454.4",
                                                                                        width:
                                                                                          "180.3",
                                                                                        height:
                                                                                          "58",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "g",
                                                                              [
                                                                                _c(
                                                                                  "defs",
                                                                                  [
                                                                                    _c(
                                                                                      "rect",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            id: "SVGID_00000154406058524606592660000013395783620037104769_",
                                                                                            x: "743.7",
                                                                                            y: "454.4",
                                                                                            width:
                                                                                              "180.3",
                                                                                            height:
                                                                                              "58",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "clipPath",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        id: "SVGID_00000089556952912372820230000015691731146153408703_",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "use",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            overflow:
                                                                                              "visible",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            "xlink:href":
                                                                                              "#SVGID_00000154406058524606592660000013395783620037104769_",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000168818008316031312350000017916105627422754688_",
                                      points:
                                        "778.5,511.6 770.6,546.4 818.3,519.9\n\t\t\t\t\t\t924,456.1 778.5,511.6 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("use", {
                                  staticStyle: {
                                    overflow: "visible",
                                    fill: "#6B59A6",
                                  },
                                  attrs: {
                                    "xlink:href":
                                      "#SVGID_00000168818008316031312350000017916105627422754688_",
                                  },
                                }),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000147214249367383338250000010130001030558811837_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000168818008316031312350000017916105627422754688_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000147214249367383338250000010130001030558811837_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000112617958892775257660000007626483349160773253_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c("use", {
                                          staticStyle: {
                                            overflow: "visible",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            "xlink:href":
                                              "#SVGID_00000112617958892775257660000007626483349160773253_",
                                          },
                                        }),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000012474407118856662560000006633074171986596525_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000112617958892775257660000007626483349160773253_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000012474407118856662560000006633074171986596525_)",
                                            fill: "#6B59A6",
                                          },
                                          attrs: {
                                            x: "768.1",
                                            y: "453.6",
                                            width: "157.9",
                                            height: "94.9",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("polyline", {
                                  staticClass: "st384",
                                  attrs: {
                                    id: "SVGID_00000069393821771442327770000003258679590575020177_",
                                    points:
                                      "924,456.1 833.2,559.7\n\t\t\t\t\t796.7,529 924,456.1 \t\t\t\t",
                                  },
                                }),
                              ]),
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000087407819624859169860000012782787858591305355_",
                                      points:
                                        "924,456.1 833.2,559.7 796.7,529 924,456.1\n\t\t\t\t\t\t\t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000142891805432498598560000012147801904659706520_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000087407819624859169860000012782787858591305355_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000142891805432498598560000012147801904659706520_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("rect", {
                                          staticClass: "st384",
                                          attrs: {
                                            id: "SVGID_00000057857180248773200100000018408175993939612544_",
                                            x: "-192",
                                            y: "-84.9",
                                            width: "1504",
                                            height: "1002.4",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000032646847983799127060000007249286370327191983_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000049934957594855459300000013842527131383816862_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000032646847983799127060000007249286370327191983_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000049934957594855459300000013842527131383816862_)",
                                              "enable-background": "new",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("g", [
                                                  _c("rect", {
                                                    staticClass: "st384",
                                                    attrs: {
                                                      id: "SVGID_00000000217022061478546630000001835811148248326278_",
                                                      x: "795.1",
                                                      y: "454.4",
                                                      width: "129.3",
                                                      height: "107",
                                                    },
                                                  }),
                                                ]),
                                                _c("g", [
                                                  _c("defs", [
                                                    _c("rect", {
                                                      attrs: {
                                                        id: "SVGID_00000096742619154139353970000015638058717250925748_",
                                                        x: "795.1",
                                                        y: "454.4",
                                                        width: "129.3",
                                                        height: "107",
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "clipPath",
                                                    {
                                                      attrs: {
                                                        id: "SVGID_00000016754910195042658720000010308068192898294165_",
                                                      },
                                                    },
                                                    [
                                                      _c("use", {
                                                        staticStyle: {
                                                          overflow: "visible",
                                                        },
                                                        attrs: {
                                                          "xlink:href":
                                                            "#SVGID_00000096742619154139353970000015638058717250925748_",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "g",
                                                    {
                                                      staticStyle: {
                                                        "clip-path":
                                                          "url(#SVGID_00000016754910195042658720000010308068192898294165_)",
                                                      },
                                                    },
                                                    [
                                                      _c("g", [
                                                        _c("g", [
                                                          _c("polyline", {
                                                            staticClass:
                                                              "st384",
                                                            attrs: {
                                                              id: "SVGID_00000152256585964372466310000009917874816932860049_",
                                                              points:
                                                                "924,456.1\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t833.2,559.7 796.7,529 924,456.1 \t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                            },
                                                          }),
                                                        ]),
                                                        _c("g", [
                                                          _c("defs", [
                                                            _c("polyline", {
                                                              attrs: {
                                                                id: "SVGID_00000096031531848048535140000005898631057902538414_",
                                                                points:
                                                                  "924,456.1 833.2,559.7 796.7,529\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t924,456.1 \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            }),
                                                          ]),
                                                          _c(
                                                            "clipPath",
                                                            {
                                                              attrs: {
                                                                id: "SVGID_00000131366525454984980850000016407217265259567749_",
                                                              },
                                                            },
                                                            [
                                                              _c("use", {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "visible",
                                                                },
                                                                attrs: {
                                                                  "xlink:href":
                                                                    "#SVGID_00000096031531848048535140000005898631057902538414_",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "g",
                                                            {
                                                              staticStyle: {
                                                                "clip-path":
                                                                  "url(#SVGID_00000131366525454984980850000016407217265259567749_)",
                                                              },
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("rect", {
                                                                    staticClass:
                                                                      "st384",
                                                                    attrs: {
                                                                      id: "SVGID_00000124148234631638589600000007858087448972204989_",
                                                                      x: "795.1",
                                                                      y: "454.4",
                                                                      width:
                                                                        "129.3",
                                                                      height:
                                                                        "107",
                                                                    },
                                                                  }),
                                                                ]),
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000049187345954867056060000018299494958608079008_",
                                                                        x: "795.1",
                                                                        y: "454.4",
                                                                        width:
                                                                          "129.3",
                                                                        height:
                                                                          "107",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000098920483824125129410000013491953193195983508_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000049187345954867056060000018299494958608079008_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          opacity:
                                                                            "0",
                                                                          "clip-path":
                                                                            "url(#SVGID_00000098920483824125129410000013491953193195983508_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "g",
                                                                        {
                                                                          staticClass:
                                                                            "st5",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "g",
                                                                            [
                                                                              _c(
                                                                                "g",
                                                                                [
                                                                                  _c(
                                                                                    "g",
                                                                                    [
                                                                                      _c(
                                                                                        "rect",
                                                                                        {
                                                                                          staticClass:
                                                                                            "st384",
                                                                                          attrs:
                                                                                            {
                                                                                              id: "SVGID_00000163072171126544687700000016477296701677117367_",
                                                                                              x: "795.1",
                                                                                              y: "454.4",
                                                                                              width:
                                                                                                "129.3",
                                                                                              height:
                                                                                                "107",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "g",
                                                                                    [
                                                                                      _c(
                                                                                        "defs",
                                                                                        [
                                                                                          _c(
                                                                                            "rect",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  id: "SVGID_00000111178633888302601630000003164004084836958111_",
                                                                                                  x: "795.1",
                                                                                                  y: "454.4",
                                                                                                  width:
                                                                                                    "129.3",
                                                                                                  height:
                                                                                                    "107",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "clipPath",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              id: "SVGID_00000075869967200823558730000007786617793501269415_",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "use",
                                                                                            {
                                                                                              staticStyle:
                                                                                                {
                                                                                                  overflow:
                                                                                                    "visible",
                                                                                                },
                                                                                              attrs:
                                                                                                {
                                                                                                  "xlink:href":
                                                                                                    "#SVGID_00000111178633888302601630000003164004084836958111_",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                              _c("g", [
                                                                _c("g", [
                                                                  _c("rect", {
                                                                    staticClass:
                                                                      "st384",
                                                                    attrs: {
                                                                      id: "SVGID_00000048473048654299726330000013899457721278679446_",
                                                                      x: "795.1",
                                                                      y: "454.4",
                                                                      width:
                                                                        "129.3",
                                                                      height:
                                                                        "107",
                                                                    },
                                                                  }),
                                                                ]),
                                                                _c("g", [
                                                                  _c("defs", [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        id: "SVGID_00000111191956292850663040000016374143144783120034_",
                                                                        x: "795.1",
                                                                        y: "454.4",
                                                                        width:
                                                                          "129.3",
                                                                        height:
                                                                          "107",
                                                                      },
                                                                    }),
                                                                  ]),
                                                                  _c(
                                                                    "clipPath",
                                                                    {
                                                                      attrs: {
                                                                        id: "SVGID_00000078748278474642268430000016106764989909531305_",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "use",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              overflow:
                                                                                "visible",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "xlink:href":
                                                                                "#SVGID_00000111191956292850663040000016374143144783120034_",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "g",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "clip-path":
                                                                            "url(#SVGID_00000078748278474642268430000016106764989909531305_)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c("g", [
                                                                        _c(
                                                                          "g",
                                                                          [
                                                                            _c(
                                                                              "g",
                                                                              [
                                                                                _c(
                                                                                  "rect",
                                                                                  {
                                                                                    staticClass:
                                                                                      "st384",
                                                                                    attrs:
                                                                                      {
                                                                                        id: "SVGID_00000095303764804588160470000014310932135060778912_",
                                                                                        x: "795.1",
                                                                                        y: "454.4",
                                                                                        width:
                                                                                          "129.3",
                                                                                        height:
                                                                                          "107",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "g",
                                                                              [
                                                                                _c(
                                                                                  "defs",
                                                                                  [
                                                                                    _c(
                                                                                      "rect",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            id: "SVGID_00000110453014639143247890000010355500650179816092_",
                                                                                            x: "795.1",
                                                                                            y: "454.4",
                                                                                            width:
                                                                                              "129.3",
                                                                                            height:
                                                                                              "107",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "clipPath",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        id: "SVGID_00000072260336868496262550000012013054656288586113_",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "use",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            overflow:
                                                                                              "visible",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            "xlink:href":
                                                                                              "#SVGID_00000110453014639143247890000010355500650179816092_",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("polyline", {
                                    attrs: {
                                      id: "SVGID_00000095339285269997066690000000834976300487590314_",
                                      points:
                                        "802.5,534 770.6,546.4 796.7,529 802.5,534\n\t\t\t\t\t\t\t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("use", {
                                  staticStyle: {
                                    overflow: "visible",
                                    fill: "#3E3F6F",
                                  },
                                  attrs: {
                                    "xlink:href":
                                      "#SVGID_00000095339285269997066690000000834976300487590314_",
                                  },
                                }),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000136399397812545105120000014469409525791642780_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000095339285269997066690000000834976300487590314_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000136399397812545105120000014469409525791642780_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000117636044647762437960000018010178366965110676_",
                                              x: "-192",
                                              y: "-84.9",
                                              width: "1504",
                                              height: "1002.4",
                                            },
                                          }),
                                        ]),
                                        _c("use", {
                                          staticStyle: {
                                            overflow: "visible",
                                            fill: "#3E3F6F",
                                          },
                                          attrs: {
                                            "xlink:href":
                                              "#SVGID_00000117636044647762437960000018010178366965110676_",
                                          },
                                        }),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000182527090034120524730000017785344736762518423_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000117636044647762437960000018010178366965110676_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000182527090034120524730000017785344736762518423_)",
                                            fill: "#3E3F6F",
                                          },
                                          attrs: {
                                            x: "768.1",
                                            y: "527",
                                            width: "36.5",
                                            height: "21.6",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _c("g", [
                          _c("path", {
                            staticClass: "st404",
                            attrs: {
                              d: "M206.6,962c5.8,0.6,11.2,1.2,15.8,4.9c2.9,2.2,8,8.1,8,18.3c0,1.3-0.1,4.2-1,7.5c-0.9,3.5-3.8,11.7-12.2,17\n\t\tc-3,1.8-7.1,3.4-10.5,4.6l19.6,39.5h-22.2c-2.1-5.5-4.2-10.9-6.7-16.2c-2.4-5.4-5-10.8-7.5-16.1c-3.1-6.5-6.2-12.8-9.2-19.2\n\t\tc3,0.3,6,0.6,9,0.6c2.4,0,12.7-0.1,17.9-7.4c2.4-3.4,2.6-6.9,2.6-8.5c0-1.5-0.3-5.5-3.4-8c-1.9-1.6-3.7-2.1-9-2.4l-19.7,0.1\n\t\tc-1.2,18-2.2,36-2.8,54c-0.3,7.8-0.4,15.3-0.6,23h-20.2c0.9-9.9,1.6-19.7,2.1-29.7c0.4-7.7,0.6-15.3,0.9-23\n\t\tc0.4-8.1,0.8-16.2,0.9-24.3c0.1-4.9,0.1-9.7,0.1-14.6H206.6L206.6,962z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st404",
                            attrs: {
                              d: "M485.9,961.9c-1,15.6-2.1,31.3-2.9,46.9c-0.8,15-1.3,29.9-1.9,45h-20.2c1.3-15.8,2.5-31.5,3.3-47.3\n\t\tc0.6-14.9,0.9-29.7,1.3-44.7L485.9,961.9z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M260.1,983.6c-1,11.9-2,23.8-2.8,35.7c-0.8,11.4-1.2,22.8-1.9,34.2H236c1.2-12,2.4-24,3.2-36\n\t\tc0.6-11.3,0.9-22.6,1.2-34L260.1,983.6z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M322.5,996.6c-7.2-1.5-14.7-3.2-22.3-3.2c-6.6,0-9.3,1.3-11.1,3.3c-0.4,0.4-1.4,1.7-1.4,3.2\n\t\tc0,2.7,2.8,4.7,5.2,6.4c4.7,3,9.3,6,14.1,9.2c3.7,2.5,7.2,5.1,10.8,7.7c2.1,1.9,7.5,5.9,7.5,13c0,2.7-0.9,8.3-7.7,12.9\n\t\tc-5.8,3.9-12.3,4.7-19.8,5.5c-14.6,0.2-18.1-0.3-31.8-3.4l-0.9-13.5c2,0.8,3.9,1.5,6.1,2.2c9.1,3,17.5,3.4,21.3,3.4\n\t\tc2.4,0,5.6-0.1,7.7-0.8c1.2-0.3,5.8-1.8,5.8-5.4c0-2.8-2.8-4.8-5.7-6.9c-2.9-2-5.8-4-8.7-5.9c-2.9-1.9-5.8-3.7-8.6-5.7\n\t\tc-1.9-1.3-3.8-2.8-5.7-4.2c-2.3-1.9-8.5-6.7-8.5-14.6c0-5.3,3-10.6,8.9-13.7c1.4-0.7,3.2-1.5,6.6-2.3c8.5-2.1,13.4-1.8,17.6-1.8\n\t\tc6,0.2,9,0.2,19.4,2L322.5,996.6z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M355.8,983.6c-0.6,4.5-1.2,9.1-1.6,13.7c-0.8,7-1,13.9-1.5,21c-0.4,7.9-0.9,15.8-1.2,23.8\n\t\tc0,3.8-0.1,7.6-0.1,11.4h-19.9c0.6-5.5,1.2-11,1.8-16.4c0.4-5.4,0.6-10.7,0.9-16.2c0.6-9,1.2-18.1,1.5-27c0.1-3.5,0.1-6.9,0.3-10.4\n\t\tL355.8,983.6z M417.1,983.6c-6.6,5.4-13.2,10.9-19.9,16.3c-4.7,3.9-9.5,7.6-14.2,11.5c-2.3,2-4.5,4-6.6,6l39.2,36.1h-26\n\t\tc-5.4-5.9-10.9-11.7-16.5-17.3c-6.3-6.4-12.9-12.5-19.4-18.6c4.7-4.2,9.5-8.3,14.3-12.4c0.1-0.1,0.3-0.3,0.4-0.4\n\t\tc4.7-3.9,9.3-7.7,13.7-11.7c3.4-3.2,6.6-6.4,9.8-9.6L417.1,983.6z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M530.4,983.5c3.3,6.1,6.7,12.3,10.2,18.3c4.2,6.9,8.7,13.8,12.9,20.7c3.9,6.4,7.8,12.8,11.7,19.2\n\t\tc0.6-8.1,1.2-16.2,1.9-24.2c0.6-6.9,1.2-13.8,1.5-20.7c0.3-4.4,0.4-8.9,0.5-13.4l17.9,0.1c-1.4,12.9-2.8,25.8-3.8,38.8\n\t\tc-0.8,10.4-1.2,20.9-1.5,31.4l-29.6-0.1c-3.6-6.3-7.1-12.7-10.9-19c-3.9-6.3-8.1-12.5-11.9-18.8c-4.2-6.9-8.2-13.9-12.3-20.8\n\t\tc-0.8,10.3-1.5,20.6-2.4,30.8c-0.4,6.2-0.9,12.3-1.2,18.5v9.4l-17.4-0.1c1-9.6,2.1-19.3,2.8-29.1c0.4-5.7,0.6-11.4,0.9-17.1\n\t\tc0.4-5.3,0.9-10.5,1-15.8v-8.2L530.4,983.5z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M648.4,996.6c-7.2-1.5-14.7-3.2-22.3-3.2c-6.6,0-9.3,1.3-11.1,3.3c-0.4,0.4-1.4,1.7-1.4,3.2\n\t\tc0,2.7,2.8,4.7,5.2,6.4c4.7,3,9.3,6,14.1,9.2c3.7,2.5,7.2,5.1,10.8,7.7c2.1,1.9,7.5,5.9,7.5,13c0,2.7-0.9,8.3-7.7,12.9\n\t\tc-5.8,3.9-12.3,4.7-19.8,5.5c-14.6,0.2-18.1-0.3-31.8-3.4l-0.9-13.5c2,0.8,3.9,1.5,6.1,2.2c9.1,3,17.5,3.4,21.3,3.4\n\t\tc2.4,0,5.6-0.1,7.7-0.8c1.2-0.3,5.8-1.8,5.8-5.4c0-2.8-2.8-4.8-5.7-6.9c-2.9-2-5.8-4-8.7-5.9c-2.9-1.9-5.8-3.7-8.6-5.7\n\t\tc-1.9-1.3-3.8-2.8-5.7-4.2c-2.3-1.9-8.5-6.7-8.5-14.6c0-5.3,3-10.6,8.9-13.7c1.4-0.7,3.2-1.5,6.6-2.3c8.5-2.1,13.4-1.8,17.6-1.8\n\t\tc6,0.2,9,0.2,19.4,2L648.4,996.6z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M680.9,983.6c-1,11.9-2,23.8-2.8,35.7c-0.8,11.4-1.2,22.8-1.9,34.2h-19.5c1.2-12,2.4-24,3.2-36\n\t\tc0.6-11.3,0.9-22.6,1.2-34L680.9,983.6z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M709.4,983.4c5.6-0.1,11.1-0.3,16.6-0.3c5.7,0,11.3,0.2,16.8,0.4c8.1,1,13.5,1.9,19.5,6.5\n\t\tc3.9,3,6.1,6.5,6.9,7.8c3.9,7,3.8,13.5,3.6,21.2c-0.8,6.9-1.2,8.4-3.7,15c-0.4,0.8-0.8,1.6-1.2,2.4c-1.5,2.7-5.2,9.1-14.3,13.2\n\t\tc-3.8,1.7-6.9,2.4-15,3.3c-6.9,0.3-13.5,0.6-20.6,0.6c-3.8,0-7.7-0.1-11.5-0.1c-5.8,0-11.7,0-17.5,0.1c0.6-6,1.4-12,1.8-18\n\t\tc0.3-4.9,0.4-9.8,0.8-14.7c0.4-6.9,0.9-13.9,1.2-20.9c0.3-5.5,0.3-11,0.4-16.5L709.4,983.4L709.4,983.4z M708.4,1041.5\n\t\tc5.8,0,11.8,0.1,17.5-0.2l6.5-0.3c0.4-0.1,4.1-0.5,6.3-1.2c2.1-0.6,6.9-2.2,10.2-6.4c3.9-4.8,6.1-12.4,6.1-18\n\t\tc0-3-0.4-14.9-14.1-18.8c-3.2-0.9-5.8-1-9.1-1.2H711L708.4,1041.5z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M848.6,983.4l-0.5,12.5c-7.8-0.4-15.7-0.7-23.7-0.7c-7.7,0-15.5,0.2-23.2,0.4l-0.8,15.9l41-0.3l-0.8,12.7\n\t\tc-7.2-0.2-14.6-0.5-21.8-0.5c-6.5,0-12.8,0.1-19.1,0.3l-1,17.8c8.9,0.1,17.9,0.3,26.7,0.1c6.9-0.2,13.5-0.5,20.4-0.9v12.7h-67.1\n\t\tc0.5-3.9,1-7.7,1.4-11.6c0.5-5.8,0.8-11.6,1-17.3c0.5-7.9,1-15.9,1.2-23.8c0.3-5.8,0.3-11.5,0.4-17.3L848.6,983.4L848.6,983.4z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M902.4,983.7c5.6,0.4,10.8,0.9,15.2,3.7c2.8,1.7,7.7,6.2,7.7,13.9c0,1-0.1,3.2-1,5.7\n\t\tc-0.9,2.7-3.7,8.9-11.8,12.9c-2.9,1.4-6.9,2.6-10.2,3.5l18.9,30.1H900c-2-4.2-4.1-8.3-6.5-12.4c-2.3-4.1-4.8-8.2-7.2-12.2\n\t\tc-3-4.9-6-9.8-8.9-14.6c2.9,0.2,5.8,0.4,8.7,0.4c2.3,0,12.3-0.1,17.3-5.6c2.3-2.6,2.5-5.3,2.5-6.5c0-1.1-0.3-4.2-3.3-6.1\n\t\tc-1.9-1.2-3.6-1.6-8.6-1.8l-19,0.1c-1.2,13.7-2.1,27.4-2.7,41.1c-0.3,5.9-0.4,11.7-0.5,17.5h-19.5c0.9-7.5,1.5-15,2-22.6\n\t\tc0.4-5.8,0.6-11.7,0.9-17.5c0.4-6.2,0.8-12.3,0.9-18.5c0.1-3.7,0.1-7.4,0.1-11.1H902.4L902.4,983.7z",
                            },
                          }),
                        ]),
                      ]
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v("Risk Insider")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }